import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SessionStorageService, LocalStorageService } from 'ngx-webstorage';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { PaymentBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storepaymentbase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { EmailBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-useremailbase';
import { AlertComponent } from 'ngx-bootstrap/alert/ngx-bootstrap-alert';
import { HttpResponse } from '@angular/common/http';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { Location } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { ReferralBase } from '../../ecom-base-entities/ecom-stores-base/ecom-referralbase';
import { Base64 } from 'js-base64';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
declare const google: any;
@Component({
  selector: 'app-ecom-payment-methods',
  templateUrl: './ecom-payment-methods.component.html',
  styleUrls: ['./ecom-payment-methods.component.scss']
})
export class EcomPaymentMethodsComponent implements OnInit {
  // component class properties
  displaycard = false;
  cardList = [];
  addPaymentMethodView = false;
  cardForm: any;
  rhPaymentForm: FormGroup;
  AmBankPaymentForm: FormGroup;
  serviceType = 'DINE_IN';
  clickEvent = '';
  settings: any;
  locationSelected: any;
  locationDetails: any;
  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  alerts: any[] = [{
    type: 'warning',
    msg: 'limit exceeds',
    timeout: 5000,
    isOpen: false
  }];
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered'
  };
  @ViewChild('paymentfailure', { static: true }) paymentfailure: ElementRef;
  @ViewChild('proceedpayment', { static: true }) proceedpayment: ElementRef;
  @ViewChild('signup', { static: true }) signup: ElementRef;
  payatCounter = false;
  chargetoRoom = false;
  retrycount = 0;
  paymentTypeSelected: any;
  PaymentTypeSelectedName = '';
  OfferApplied = 'none';
  NextDiscountApplied = -1;
  discountApplied: any;
  environment: any;
  referredList = [];
  referralDiscountApplied = false;
  taxList = [];

  TotalOrderAmount = 0;
  CashbackEarnedAmount = 0;
  PaymentAmount = 0;
  referralDiscountAmount = 0;
  subTotalAmount = 0;
  serviceCharges = 0;
  deliveryCharges = 0;
  servicechagePercentage = 0;
  taxTotal = 0;
  referralCart = undefined;
  signupmobile: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
  voucherAmount = 0;
  signupform: FormGroup;
  usertoken = undefined;
  paymentError = 'Unknown Error';
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public router: Router, public ecomservice: EComService, public formBuilder: FormBuilder, private webstorage: EComWebStorage,
    public location: Location, public activatedRoute: ActivatedRoute, private modalService: BsModalService, private cookie: EcomCookies) {
    this.environment = olarconfig.Environment;
  }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'payment reservation'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    this.usertoken = (this.cookie.cookie_authtoken && this.webstorage.localSt_user_id) ? true : false;
    if (this.webstorage.sessionSt_frompage && this.webstorage.sessionSt_frompage === 'status') {
      this.router.navigate(['home']);
    } else {
      this.webstorage.sessionSt_qr_scan_current_page = this.router.url;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.displaycard = false;
      this.signupform = this.formBuilder.group({
        mobile: ['', Validators.compose([Validators.required])],
      });
      this.cardForm = this.formBuilder.group({
        card_number: ['', Validators.compose([Validators.required])],
        name_oncard: ['', Validators.compose([Validators.required])],
        expiry: ['', Validators.compose([Validators.required])],
        cvv: ['', Validators.compose([Validators.required])]
      });
      this.rhPaymentForm = this.formBuilder.group({
        Revpay_Merchant_ID: [],
        Payment_ID: [],
        Bank_Code: [],
        Reference_Number: [],
        Amount: [],
        Currency: [],
        Transaction_Description: [],
        Customer_Name: [],
        Customer_Email: [],
        Customer_Contact: [],
        Customer_IP: [],
        Installment_Plan: [],
        Installment_Term: [],
        Key_Index: [],
        Signature: [],
        Return_URL: []
      });
      this.AmBankPaymentForm = this.formBuilder.group({
        MERCHANT_ACC_NO: [],
        MERCHANT_TRANID: [],
        AMOUNT: [],
        TRANSACTION_TYPE: [],
        SECURE_SIGNATURE: [],
        RESPONSE_TYPE: [],
        RETURN_URL: [],
        TXN_DESC: [],
        CUSTOMER_ID: [],
        FR_HIGHRISK_EMAIL: [],
        FR_CUSTOMER_IP: []
      });
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['status']) {
          if(params['error']){
            this.paymentError = params['error'];
          }
          this.modalRef = this.modalService.show(this.paymentfailure, this.config);
        }
      });
      if (this.webstorage.sessionSt_frompage === 'checkout' || this.webstorage.sessionSt_frompage === 'store' || this.webstorage.sessionSt_frompage === 'payment' || this.webstorage.sessionSt_frompage === 'login' || this.webstorage.sessionSt_frompage === 'items') {
        if (this.webstorage.sessionSt_location_selected === null) {
          this.router.navigate(['home']);
        } else {
          this.LoadPage();
        }
      } else {
        this.router.navigate(['home']);
      }
      this.getMyIp();
    }
  }

  getMyIp() {
    this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', false).subscribe((response: HttpResponse<any>) => {
      if (response.status === 200) {
        this.webstorage.localSt_ip = response.body.ip;
          this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
          this.webstorage.localSt_countrycode = response.body.country_code2;

      }
    });
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage();
        }
      });
    } else {
      this.initPage();
    }
  }

  initPage() {
    this.payatCounter = this.webstorage.sessionSt_scanned_dinein_table == null ? false : this.webstorage.sessionSt_scanned_dinein_table;
    this.chargetoRoom = this.webstorage.sessionSt_scanned_area_room === null ? false : this.webstorage.sessionSt_scanned_area_room;
    this.serviceType = this.webstorage.sessionSt_service_type;
    this.settings = this.webstorage.sessionSt_settings;
    this.locationSelected = this.webstorage.sessionSt_location_selected;
    this.locationDetails = this.webstorage.sessionSt_orderlocation_details;
    this.userServiceBase = this.webstorage.localSt_user_service_request;
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    this.userSelectedStore = selectedStore;
    if (this.settings.oosrcs_allow_referral) {
      this.getReferredDetails(selectedStore.serviceUserDialCode, selectedStore.serviceUserMobilenumber, selectedStore.serviceCompanyGuid);
    }
    if (this.webstorage.sessionSt_location_selected) {
      var encoded = Base64.encode(this.webstorage.sessionSt_location_selected.oocls_company_id);
      this.location.replaceState(this.location.path(), '?webcompanyid=' + encoded);
    }
  }

  // Method to handle the back button click
  onBackClick() {
    this.clickEvent = 'BACK';
    if (this.serviceType === 'RESERVATION') {
      this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
    } else {
      this.router.navigate(['checkout', this.webstorage.sessionSt_company_clicked]);
    }
  }

  getTaxList(cartItems) {
    this.taxList = [];
    const companyTaxes = this.settings.ListCompanyTax;
    for (let i = 0; i < companyTaxes.length; i++) {
      // filter items based on tax
      // item tax
      const taxitems = cartItems.filter(x => x.variantList[0].variantTaxGuid === companyTaxes[i].tax_guid && x.variantList[0].variantQty > 0);
      if (taxitems.length > 0) {
        // check if taxtype already exist in list
        // calculate tax for vairants
        let taxIndex = -1;
        let taxinlist = this.taxList.find((obj, index) => {
          taxIndex = index;
          return obj.tax_guid === companyTaxes[i].tax_guid;
        });
        if (taxinlist === undefined) {
          taxinlist = {
            tax_guid: companyTaxes[i].tax_guid,
            name: companyTaxes[i].tax_name + '(' + companyTaxes[i].tax_rate + '%)',
            amount: 0,
            display: true
          };
          taxitems.forEach(taxitem => {
            if (this.serviceType === 'DINE_IN') {
              taxinlist.amount = taxinlist.amount + (taxitem.variantList[0].VariantTotalTax);
            } else {
              taxinlist.amount = taxinlist.amount + (taxitem.variantList[0].VariantTotalTax);
            }
          });
          taxinlist.amount = Number(Number(taxinlist.amount).toFixed(2));
          this.taxList.push(taxinlist);
        } else {
          taxitems.forEach(taxitem => {
            if (this.serviceType === 'DINE_IN') {
              this.taxList[taxIndex].amount = this.taxList[taxIndex].amount + (taxitem.variantList[0].VariantTotalTax);
            } else {
              this.taxList[taxIndex].amount = this.taxList[taxIndex].amount + (taxitem.variantList[0].VariantTotalTax);
            }
            this.taxList[taxIndex].amount = Number(Number(this.taxList[taxIndex].amount).toFixed(2));
          });
        }
      }
      // modifier tax
      for (let cartItemindex = 0; cartItemindex < cartItems.length; cartItemindex++) {
        if (cartItems[cartItemindex].variantList[0].variantQty > 0) {
          for (let modifierSetIndex = 0; modifierSetIndex < cartItems[cartItemindex].modifierSetList.length; modifierSetIndex++) {
            const taxmodifierOptions = cartItems[cartItemindex].modifierSetList[modifierSetIndex].modifierOptions.filter(x => x.optionTaxGuid === companyTaxes[i].tax_guid && x.optionSelected === true);
            if (taxmodifierOptions.length > 0) {
              // check if taxtype already exist in list
              // calculate tax for modifier options
              let taxIndex = -1;
              let taxinlist = this.taxList.find((obj, index) => {
                taxIndex = index;
                return obj.tax_guid === companyTaxes[i].tax_guid;
              });
              if (taxinlist === undefined) {
                taxinlist = {
                  tax_guid: companyTaxes[i].tax_guid,
                  name: companyTaxes[i].tax_name + '(' + companyTaxes[i].tax_rate + '%)',
                  amount: 0,
                  display: true
                };
                taxmodifierOptions.forEach(options => {
                  if (options.optionSelected) {
                    taxinlist.amount = taxinlist.amount + (options.optionTaxAmt * options.optionQuantity);
                  }
                });
                taxinlist.amount = Number(Number(taxinlist.amount).toFixed(2))
                this.taxList.push(taxinlist);
              } else {
                taxmodifierOptions.forEach(options => {
                  if (options.optionSelected) {
                    this.taxList[taxIndex].amount = this.taxList[taxIndex].amount + (options.optionTaxAmt * options.optionQuantity);
                    this.taxList[taxIndex].amount = Number(Number(this.taxList[taxIndex].amount).toFixed(2));
                  }
                });
              }
            }
          }
        }
      }
    }
    this.updateTaxDisplay();
  }

  updateTaxDisplay() {
    if (this.taxList.length > 0) {
      this.taxList.forEach(element => {
        // check if this tax exist in cartitems
        const cartItems = this.userSelectedStore.storeCart.orderItems;
        const itemvariantTaxExist = cartItems.find(obj => {
          return obj.variantList[0].variantTaxGuid === element.tax_guid;
        });
        if (itemvariantTaxExist === undefined) {
          // check in modifiers
          let modifiertaxExist = false;
          for (let i = 0; i < cartItems.length; i++) {
            let modiferSets = cartItems[i].modifierSetList;
            for (let j = 0; j < modiferSets.length; j++) {
              const optiontaxExist = modiferSets[j].modifierOptions.find(option => {
                return option.optionTaxGuid === element.tax_guid && option.optionSelected === true;
              });
              if (optiontaxExist) {
                modifiertaxExist = true;
                break;
              }
            }
            if (modifiertaxExist) {
              break;
            }
          }
          if (!modifiertaxExist) {
            element.display = false;
          } else {
            element.display = true;
          }
        } else {
          element.display = true;
        }
      });
    }
  }

  getReferredDetails(dialcode, phonenumber, companyGuid) {
    const input = {
      oocr_customer_dial_code: this.ecomservice.encryptWithKey(dialcode),
      oocr_customer_mobile: this.ecomservice.encryptWithKey(phonenumber),
      user_public_key: this.webstorage.localSt_olar_key
    };
    this.ecomservice.httpPost(EcomNetworkUtils.POST_REFERRED_DETAILS, input, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.referredList = [];
          const referralOrdered = response.listValues.filter(x => x.oocr_referral_ordered === true && x.oocr_customer_claimed === false && x.oocr_company_guid === companyGuid);
          referralOrdered.forEach(element => {
            const objReferred = {
              merchantname: element.MerchantName,
              referredcontactnumber: element.ReferredContact,
              referralredeemed: element.ReferralRedeemed,
              readyForRedemption: element.ReadyForRedemption,
              referral_ordered: element.oocr_referral_ordered
            };
            this.referredList.push(objReferred);
          });
          if (this.referredList.length > 0) {
            this.referralDiscountApplied = true;
          } else {
            this.referralDiscountApplied = false;
          }
        }
      }
    });
  }

  onPaymentClick(type, cashondeliveryOrCollection = false) {
    if (this.usertoken) {
      if (this.serviceType === 'RESERVATION') {
        this.saveReservation(type);
      } else {
        this.ProceedToPayment(type);
      }
    } else {
      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }
      let userStoreIndex = -1;
      const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        userStoreIndex = index;
        return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
      });
      this.userSelectedStore = selectedStore;

      // check if the user already signed in and verified
      // check the client is already exist for this phone number

      const inputcontact = {
        ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userSelectedStore.serviceUserMobilenumber.replace('-', '').replace(' ', '')),
        ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userSelectedStore.serviceUserDialCode),
        customer_client_key: this.webstorage.localSt_client_id,
        customer_key: this.webstorage.localSt_olar_key
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_USEREXIST_VERIFIED, inputcontact, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            if (this.serviceType === 'RESERVATION') {
              this.saveReservation(type);
            } else {
              this.ProceedToPayment(type);
            }
          } else {
            this.signupform.controls['mobile'].setValue(this.userSelectedStore.serviceUserMobilenumber);
            this.signupmobile = this.userSelectedStore.serviceUserMobilenumber.replace('-', '').replace(' ', '');
            this.modalRef = this.modalService.show(this.signup, this.config);
          }
        }
      });
    }
  }

  ProceedToPayment(type) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    this.userSelectedStore = selectedStore;
    this.TotalOrderAmount = Number(this.userSelectedStore.storeCart.orderTotal.toFixed(2));
    this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2))
    //this.PaymentAmount = this.TotalOrderAmount;
    this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;
    this.CashbackEarnedAmount = 0;
    this.getPaymentId(type);
    this.paymentTypeSelected = type;
    //this.modalRef = this.modalService.show(this.proceedpayment, this.config);
    if (this.referralDiscountApplied) {
      this.modalRef = this.modalService.show(this.proceedpayment, this.config);
      this.CalculateReferralDiscount();
    } else {
      // no cashback for payatcounter/qrcode in case of dine in
      if (this.payatCounter || this.chargetoRoom || (this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        if (this.serviceType === 'DINE_IN') {
          this.saveDineIn(type);
        } else if (this.serviceType === 'COLLECTION') {
          this.saveCollection(type);
        } else if (this.serviceType === 'DELIVERY') {
          this.saveDelivery(type);
        }
      } else {

        this.modalRef = this.modalService.show(this.proceedpayment, this.config);
        if (this.webstorage.sessionSt_user_order_count_for_discount) {
          this.CalculateDisplayAmount(type);
        } else {
          let serviceActiveId = this.webstorage.sessionSt_service_active_id;
          if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
            serviceActiveId = 1;
          }
          let userStoreIndex = -1;
          const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            userStoreIndex = index;
            return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
          });
          const inputcontact = {
            ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userSelectedStore.serviceUserMobilenumber.replace('-', '').replace(' ', '')),
            ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userSelectedStore.serviceUserDialCode),
            customer_client_key: this.webstorage.localSt_client_id,
            customer_key: this.webstorage.localSt_olar_key,
            company_id: selectedStore.serviceCompanyId
          };
          this.ecomservice.httpPost(EcomNetworkUtils.POST_USER_ORDER_COUNT_FOR_DISCOUNT, inputcontact, '', true).subscribe(response => {
            if (response['status'] === 403) {
              this.router.navigate(['unauthorized']);
            } else {
              if (response.isSuccess) {
                this.webstorage.sessionSt_user_order_count_for_discount = response.value;
                this.CalculateDisplayAmount(type);
              }
            }
          });
        }
      }
    }
  }

  CalculateDisplayAmount(type) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    this.userSelectedStore = selectedStore;
    this.TotalOrderAmount = Number(this.userSelectedStore.storeCart.orderTotal.toFixed(2));
    if (type === 'Reserved') {
      this.OfferApplied = 'selecte online payment method to get cashback';
      this.CashbackEarnedAmount = 0;
      this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2))
      //this.PaymentAmount = this.TotalOrderAmount;
      this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;
    } else {
      //let countryCode = this.webstorage.localSt_user_country_code;
      let countryCode = this.cookie.cookie_country_code;
      this.ecomservice.httpGet(EcomNetworkUtils.GET_OLAR_DISCOUNTS + "?countryCode=" + countryCode, '', true).subscribe((response) => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.webstorage.sessionSt_olar_discounts = response.listValues;
            this.CalculateCashbackAmount();
          }
        }
      });
    }
  }

  CalculateCashbackAmount() {
    this.OfferApplied = 'none';
    let discount = this.GetDiscountPercentage();
    if (discount) {
      this.discountApplied = discount;
      // check if the discount is percentage or amount
      if (discount.mod_percentage) {
        let cashbackupto = 0;
        if (discount.mod_max_amount) {
          cashbackupto = discount.mod_max_amount;
        }
        this.CashbackEarnedAmount = Number(((discount.mod_percentage / 100) * this.TotalOrderAmount).toFixed(2));
        if (cashbackupto > 0 && this.CashbackEarnedAmount > cashbackupto) {
          this.CashbackEarnedAmount = cashbackupto;
        }
        this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
        this.PaymentAmount = Number((this.TotalOrderAmount - this.CashbackEarnedAmount).toFixed(2)) - this.voucherAmount;
      } else if (discount.mod_amount) {
        this.CashbackEarnedAmount = discount.mod_amount;
        this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
        this.PaymentAmount = Number((this.TotalOrderAmount - this.CashbackEarnedAmount).toFixed(2)) - this.voucherAmount;
      }
    } else {
      let groupcountnext = 0;
      let everycountnext = 0;
      const ordercount = Number(this.webstorage.sessionSt_user_order_count_for_discount);
      // get the group count which is having the least number to display user for next order cashback
      let olarDiscount = this.webstorage.sessionSt_olar_discounts;
      olarDiscount = olarDiscount.filter(x => x.mod_group_count !== null);
      // sort by group count ascending
      if (olarDiscount && olarDiscount.length > 0) {
        olarDiscount.sort((a, b) => a.mod_group_count < b.mod_group_count ? -1 : a.mod_group_count > b.mod_group_count ? 1 : 0);
        groupcountnext = ordercount % olarDiscount[0].mod_group_count;
      }
      // get the every count which is having the least number to display user for next order cashback
      olarDiscount = this.webstorage.sessionSt_olar_discounts;
      olarDiscount = olarDiscount.filter(x => x.mod_every_count !== null && x.mod_every_count > ordercount);
      if (olarDiscount && olarDiscount.length > 0) {
        olarDiscount.sort((a, b) => a.mod_every_count < b.mod_every_count ? -1 : a.mod_every_count > b.mod_every_count ? 1 : 0);
        everycountnext = ordercount % olarDiscount[0].mod_every_count;
      }
      if (groupcountnext < everycountnext) {
        this.discountApplied = groupcountnext;
      } else {
        this.discountApplied = everycountnext;
      }
    }
  }


  /*
  GetDiscountPercentage(): any {
    let discount: any = undefined;
    // loop through the olarme promos and get the applicable one
    let olarDiscount = this.webstorage.sessionSt_olar_discounts;
    olarDiscount = olarDiscount.filter(x => x.mod_priority !== null);
    const ordercount = Number(this.webstorage.sessionSt_user_order_count_for_discount) + 1;
    for (let i = 0; i < olarDiscount.length; i++) {
      discount = olarDiscount[i];
      // check for minorder amount
      if (discount.mod_min_amount && this.TotalOrderAmount >= discount.mod_min_amount) {
        if (discount.mod_every_count && discount.mod_every_count === ordercount) {
          this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          break;
        } else if (discount.mod_group_count && (ordercount % discount.mod_group_count) === 0) {
          // check for group count
          this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          break;
        } else {
          this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          break;
        }
      } else if (discount.mod_every_count && discount.mod_every_count === ordercount) {
        this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
        break;
      } else if (discount.mod_group_count && (ordercount % discount.mod_group_count) === 0) {
        this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
        break;
      } else {
        // get the discount if no condition matches
        discount = undefined;
      }
    }
    return discount;
  }
  */


  // discount including pickup discount
  GetDiscountPercentage(): any {
    let discount: any = undefined;
    const ordercount = Number(this.webstorage.sessionSt_user_order_count_for_discount) + 1;
    let olarDiscount = this.webstorage.sessionSt_olar_discounts;
    // if order type is pickup then check for pickup discount on order amount
    let pickupdiscountApplied = false;
    if (this.serviceType === 'COLLECTION') {
      olarDiscount = olarDiscount.filter(x => x.mod_type === 'PICKUP');
      // order the discount in descending of min order amount
      olarDiscount = olarDiscount.sort((a, b) => a.mod_min_amount > b.mod_min_amount ? -1 : a.mod_min_amount < b.mod_min_amount ? 1 : 0);

      for (let i = 0; i < olarDiscount.length; i++) {
        discount = olarDiscount[i];
        let discountapplied = false;
        // check for minorder amount
        if (discount.mod_min_amount && this.TotalOrderAmount >= discount.mod_min_amount) {
          discountapplied = true;
          this.OfferApplied = discount.mod_name;
        }
        if (discountapplied) {
          pickupdiscountApplied = true;
          discount = olarDiscount[i];
          break;
        } else {
          discount = undefined;
        }
      }
    }
    if (!pickupdiscountApplied) {
      // loop through the olarme promos and get the applicable one    
      olarDiscount = olarDiscount.filter(x => x.mod_priority !== null);
      for (let i = 0; i < olarDiscount.length; i++) {
        discount = olarDiscount[i];
        let discountapplied = false;
        // check for minorder amount
        if (discount.mod_min_amount && this.TotalOrderAmount >= discount.mod_min_amount) {
          if (discount.mod_every_count && discount.mod_every_count === ordercount) {
            discountapplied = true;
            this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          } else if (discount.mod_group_count && (ordercount % discount.mod_group_count) === 0) {
            discountapplied = true;
            // check for group count
            this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          } else {
            discountapplied = true;
            this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
          }
        } else if (discount.mod_every_count && discount.mod_every_count === ordercount) {
          discountapplied = true;
          this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
        } else if (discount.mod_group_count && (ordercount % discount.mod_group_count) === 0) {
          discountapplied = true;
          this.OfferApplied = discount.mod_name + ' ' + discount.mod_percentage + '%';
        } else {
          discountapplied = false;
          // get the discount if no condition matches
          discount = undefined;
        }
        if (discountapplied) {
          discount = olarDiscount[i];
          break;
        } else {
          discount = undefined;
        }
      }
    }
    return discount;
  }

  CalculateReferralDiscount() {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });

    const referralPercentage = this.settings.oosrcs_referral_percentage;

    // recaluculate total and tax amount based on tax type after discount
    const taxtype = this.settings.company_sell_price_tax;

    let discountAmount = 0;
    let paymentAmount = 0;
    let subTotalamount = 0;
    let subTotalWithDiscount = 0;
    let taxTotalWithDiscount = 0;
    const referralDiscountPercentage = this.settings.oosrcs_referral_percentage;
    let objCartBase = new StoreCartBase();
    objCartBase.orderItems = [];
    this.userSelectedStore.storeCart.orderItems.forEach(item => {
      let objItemBase = new ItemBase();
      objItemBase.variantList = [];
      objItemBase.modifierSetList = [];
      objItemBase.itemId = item.itemId;
      objItemBase.itemGuid = item.itemGuid;
      objItemBase.imagePath = item.imagePath;
      objItemBase.itemName = item.itemName;
      objItemBase.itemDescription = item.itemDescription;
      objItemBase.specialRequest = item.specialRequest;
      objItemBase.isValid = item.isValid;
      objItemBase.itemError = item.itemError;
      objItemBase.HasModifier = item.HasModifier;
      objItemBase.quantity = item.quantity;
      objItemBase.priceEach = item.priceEach;
      objItemBase.totalPrice = item.totalPrice;
      objItemBase.taxEach = item.taxEach;
      objItemBase.totalTax = item.totalTax;
      objItemBase.totalDiscountAmount = item.totalDiscountAmount;
      objItemBase.discountPercentage = item.discountPercentage;

      item.variantList.forEach(variant => {
        if (variant.selected) {
          let objVariantBase = new VariantBase();
          let priceEach = 0;
          if (this.serviceType === 'DINE_IN') {
            priceEach = variant.variantDineInPriceDiscounted ? Number(variant.variantDineInPriceDiscounted.toFixed(2).toString()) : Number(variant.variantDineInPrice.toFixed(2).toString());
          } else if (this.serviceType === 'COLLECTION') {
            priceEach = variant.variantDeliveryPriceDiscounted ? Number(variant.variantCollectionPriceDiscounted.toFixed(2).toString()) : Number(variant.variantDeliveryCollectionPrice.toFixed(2).toString());
          } else if (this.serviceType === 'DELIVERY') {
            priceEach = variant.variantDeliveryPriceDiscounted ? Number(variant.variantDeliveryPriceDiscounted.toFixed(2).toString()) : Number(variant.variantDeliveryCollectionPrice.toFixed(2).toString());
          }
          const priceTotal = Number(priceEach) * variant.variantQty;
          const discountEach = Number((referralDiscountPercentage / 100) * Number(priceEach));
          const discountTotal = Number((referralDiscountPercentage / 100) * priceTotal);
          const priceEachAfterDiscount = Number(priceEach) - discountEach;
          let priceTotalAfterDiscount = Number(priceTotal) - discountTotal;

          const eachTaxAfterDiscount = this.calculateTax(taxtype, priceEachAfterDiscount, variant.variantTaxRate);
          const totalTaxAfterDiscount = this.calculateTax(taxtype, priceTotalAfterDiscount, variant.variantTaxRate);


          discountAmount = discountAmount + discountTotal;
          paymentAmount = paymentAmount + priceTotalAfterDiscount;
          taxTotalWithDiscount = taxTotalWithDiscount + totalTaxAfterDiscount;
          subTotalWithDiscount = subTotalWithDiscount + priceTotalAfterDiscount;
          // assign to discounted cart
          objVariantBase.variantGuid = variant.variantGuid;
          objVariantBase.variantName = variant.variantName;
          objVariantBase.variantSalePrice = Number(priceEach);
          objVariantBase.discountPercentage = referralDiscountPercentage;
          objVariantBase.totalDiscountAmount = discountTotal;
          objVariantBase.totalPriceAfterDiscount = priceTotalAfterDiscount;
          objVariantBase.variantTaxGuid = variant.variantTaxGuid;
          objVariantBase.variantTaxRate = variant.variantTaxRate;
          if (this.serviceType === 'DINE_IN') {
            objVariantBase.variantDineInTaxAmt = totalTaxAfterDiscount;
          } else {
            objVariantBase.variantDineInTaxAmt = totalTaxAfterDiscount;
          }
          objVariantBase.variantAvailable = variant.variantAvailable;
          objVariantBase.variantSKU = variant.variantSKU;
          objVariantBase.variantQty = variant.variantQty;
          objVariantBase.variantTaxEach = eachTaxAfterDiscount;
          objVariantBase.VariantTotalTax = totalTaxAfterDiscount;
          objVariantBase.selected = variant.selected;
          objItemBase.variantList.push(objVariantBase);
        }
      })

      item.modifierSetList.forEach(set => {
        let objModifierSetBase = new ModifierSetBase();
        objModifierSetBase.modifiermappingGuid = set.modifiermappingGuid;
        objModifierSetBase.modifierGuid = set.modifierGuid;
        objModifierSetBase.modifierName = set.modifierName;
        objModifierSetBase.modifierSetMin = set.modifierSetMin;
        objModifierSetBase.modifierSetMax = set.modifierSetMax;
        objModifierSetBase.modifierOptions = [];
        objModifierSetBase.collapsed = set.collapsed;
        objModifierSetBase.quantity = set.quantity;
        objModifierSetBase.errorMessage = set.errorMessage;
        objModifierSetBase.modifierSetSelected = set.modifierSetSelected;
        if (set.quantity > 0) {
          set.modifierOptions.forEach(option => {
            let objModifierOptionBase = new ModifierSetOptionBase();
            objModifierOptionBase.optionGuid = option.optionGuid;
            objModifierOptionBase.optionName = option.optionName;
            objModifierOptionBase.optionPreSelected = option.optionPreSelected;
            objModifierOptionBase.optionQuantity = option.optionQuantity;
            objModifierOptionBase.optionTaxRate = option.optionTaxRate;
            objModifierOptionBase.optionTaxGuid = option.optionTaxGuid;
            objModifierOptionBase.optionSelected = option.optionSelected;
            objModifierOptionBase.optionPrice = option.optionPrice;
            objModifierOptionBase.optionTaxTotal = option.optionTaxTotal;
            objModifierOptionBase.optionPriceTotal = option.optionPriceTotal;
            if (option.optionQuantity > 0) {
              const priceEach = option.optionPrice;
              const priceTotal = Number(priceEach) * option.optionQuantity;
              const discountEach = Number((referralDiscountPercentage / 100) * Number(priceEach));
              const discountTotal = Number((referralDiscountPercentage / 100) * priceTotal);
              const priceEachAfterDiscount = Number(priceEach) - discountEach;
              let priceTotalAfterDiscount = Number(priceTotal) - discountTotal;

              const eachTaxAfterDiscount = this.calculateTax(taxtype, priceEachAfterDiscount, option.optionTaxRate);
              const totalTaxAfterDiscount = this.calculateTax(taxtype, priceTotalAfterDiscount, option.optionTaxRate);

              discountAmount = discountAmount + discountTotal;
              paymentAmount = paymentAmount + priceTotalAfterDiscount;
              taxTotalWithDiscount = taxTotalWithDiscount + totalTaxAfterDiscount;
              subTotalWithDiscount = subTotalWithDiscount + priceTotalAfterDiscount;

              objModifierOptionBase.totalPriceAfterDiscount = priceTotalAfterDiscount;
              objModifierOptionBase.totalDiscountAmount = discountTotal;
              objModifierOptionBase.discountPercentage = referralDiscountPercentage;
              objModifierOptionBase.optionSalePrice = priceEach;
              objModifierOptionBase.optionTaxAmt = eachTaxAfterDiscount;
              objModifierSetBase.modifierOptions.push(objModifierOptionBase);
            }
          })
        }
        objItemBase.modifierSetList.push(objModifierSetBase);
      })
      objCartBase.orderItems.push(objItemBase);
    })

    this.referralDiscountAmount = discountAmount;
    this.subTotalAmount = this.userSelectedStore.storeCart.orderSubTotal;
    if (this.serviceType === 'DINE_IN') {

      if (taxtype === 'TAX_IN') {
        const amountToCalculateSurcharge = subTotalWithDiscount;
        this.serviceCharges = this.getSurchargeAmout(amountToCalculateSurcharge, selectedStore.serviceDatetime);
        this.TotalOrderAmount = subTotalWithDiscount + this.serviceCharges;
      } else {
        const amountToCalculateSurcharge = subTotalWithDiscount + taxTotalWithDiscount;
        this.serviceCharges = this.getSurchargeAmout(amountToCalculateSurcharge, selectedStore.serviceDatetime);
        this.TotalOrderAmount = subTotalWithDiscount + this.serviceCharges + taxTotalWithDiscount;
      }
      objCartBase.orderServiceCharge = this.serviceCharges;
      objCartBase.orderTotal = this.TotalOrderAmount;
      this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
      //this.PaymentAmount = this.TotalOrderAmount;
      this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;
      // update the referral details
      if (selectedStore) {
        let referral: ReferralBase = {
          referral_guid: null,
          referral_mod_guid: null,
          referral_name: null,
          referral_type: '',
          referral_amount: discountAmount,
          referral_percentage: this.settings.oosrcs_referral_percentage
        };
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.referral = referral;
      }
    } else if (this.serviceType === 'COLLECTION') {
      if (taxtype === 'TAX_IN') {
        this.TotalOrderAmount = subTotalWithDiscount;
      } else {
        this.TotalOrderAmount = subTotalWithDiscount + taxTotalWithDiscount;
      }
      objCartBase.orderTotal = this.TotalOrderAmount;
      this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
      //this.PaymentAmount = this.TotalOrderAmount;
      this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;
      // update the referral details
      if (selectedStore) {
        let referral: ReferralBase = {
          referral_guid: null,
          referral_mod_guid: null,
          referral_name: null,
          referral_type: '',
          referral_amount: discountAmount,
          referral_percentage: this.settings.oosrcs_referral_percentage
        };
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.referral = referral;
      }
    } else if (this.serviceType === 'DELIVERY') {
      this.deliveryCharges = this.userSelectedStore.storeCart.orderDeliveryCharge;
      let totalAfterDiscountForDelivery = 0;
      if (taxtype === 'TAX_IN') {
        this.TotalOrderAmount = subTotalWithDiscount + this.deliveryCharges;
        totalAfterDiscountForDelivery = subTotalWithDiscount;
      } else {
        this.TotalOrderAmount = subTotalWithDiscount + taxTotalWithDiscount + this.deliveryCharges;
        totalAfterDiscountForDelivery = subTotalWithDiscount + taxTotalWithDiscount;
      }
      objCartBase.orderDeliveryCharge = this.deliveryCharges;
      this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
      //this.PaymentAmount = this.TotalOrderAmount;
      this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;
      objCartBase.orderTotal = this.TotalOrderAmount;
      // check if the total amount is eligible for free delivery    
      if (totalAfterDiscountForDelivery >= this.settings.oosrcs_free_deliver_minOrder_amount) {
        this.deliveryCharges = 0;
        objCartBase.orderDeliveryCharge = this.deliveryCharges;
        // update the referral details
        if (selectedStore) {
          let referral: ReferralBase = {
            referral_guid: null,
            referral_mod_guid: null,
            referral_name: null,
            referral_type: '',
            referral_amount: discountAmount,
            referral_percentage: this.settings.oosrcs_referral_percentage
          };
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.referral = referral;
        }
      } else {
        //let destination = this.webstorage.localSt_latlng;
        let destination = this.cookie.cookie_latlng;
        if (this.cookie.cookie_latlng_delivery_address_change) {
          destination = this.cookie.cookie_latlng_delivery_address_change;
        }
        const origin = this.webstorage.sessionSt_orderlocation_details.ools_location_latlang;
        let service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
          {
            origins: [origin],
            destinations: [destination],
            unitSystem: google.maps.UnitSystem.METRIC,
            travelMode: google.maps.TravelMode['DRIVING'],
            //avoidHighways: false,
            //avoidTolls: false
          }, (response: any, status) => {
            if (status !== google.maps.DistanceMatrixStatus.OK || status !== 'OK') {
            } else {
              const trackingInput = {
                gat_ipaddress: this.webstorage.localSt_ip,
                gat_type: 'DISTANCE MATRIX API'
              };
              this.ecomservice.googleApiTrack(trackingInput);
              let distance = {
                text: '',
                value: ''
              }
              if (response.rows.length > 0) {
                response.rows[0].elements.forEach(mat => {
                  if (mat.status === 'OK') {
                    distance = {
                      text: mat.distance.text,
                      value: mat.distance.value
                    }
                  }
                });
              }
              const deliverydistance = Number((distance.text.split(' ')[0]).replace(',', ''));
              // calculate the delivery fee based on the setting in backoffice
              const deliveryCharges = this.settings.mm_online_order_delivery_charges;
              // check if it delivered by olar or not
              let minDeliveryCharge = this.settings.oosrcs_delivery_charge;
              let minDeliveryRange = this.settings.oosrcs_delivery_min_range;
              if (deliveryCharges && deliveryCharges.length > 0) {
                for (let i = 0; i < deliveryCharges.length; i++) {
                  const delRange = deliveryCharges[i].oodc_range;
                  if (deliverydistance <= delRange) {
                    minDeliveryCharge = deliveryCharges[i].oodc_price;
                    minDeliveryRange = deliveryCharges[i].oodc_range;
                    break;
                  }
                }
              }
              this.deliveryCharges = minDeliveryCharge;
              this.TotalOrderAmount = subTotalWithDiscount + this.deliveryCharges;
              if (taxtype === 'TAX_IN') {
                this.TotalOrderAmount = subTotalWithDiscount + this.deliveryCharges;
              } else {
                this.TotalOrderAmount = subTotalWithDiscount + taxTotalWithDiscount + this.deliveryCharges;
              }
              this.voucherAmount = Number(this.userSelectedStore.storeCart.voucherAmount.toFixed(2));
              //this.PaymentAmount = this.TotalOrderAmount;
              this.PaymentAmount = this.TotalOrderAmount - this.voucherAmount;

              objCartBase.orderTotal = this.TotalOrderAmount;
              objCartBase.orderDeliveryCharge = this.deliveryCharges;
              // update the referral details
              if (selectedStore) {
                let referral: ReferralBase = {
                  referral_guid: null,
                  referral_mod_guid: null,
                  referral_name: null,
                  referral_type: '',
                  referral_amount: discountAmount,
                  referral_percentage: this.settings.oosrcs_referral_percentage
                };
                this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.referral = referral;
              }
            }
          });
      }
    }
    objCartBase.orderId = this.userSelectedStore.storeCart.orderId;
    objCartBase.cartEmpty = this.userSelectedStore.storeCart.cartEmpty;
    objCartBase.orderTax = taxTotalWithDiscount;
    objCartBase.orderSubTotal = this.userSelectedStore.storeCart.orderSubTotal;
    objCartBase.orderDiscountReferral = this.referralDiscountAmount;
    this.getTaxList(objCartBase.orderItems);
    this.referralCart = objCartBase;
  }

  // Method to calculate surcharge amount
  getSurchargeAmout(amount, datetime) {
    let surchargeAmt = 0;
    let datepart = datetime.split(' ')[0].split('-');
    let timepart = datetime.split(' ')[1].split(':');
    let ampm = datetime.split(' ')[2];
    let hour = timepart[0] === 12 ? timepart[0] : (Number(timepart[0]) + 12);
    datetime = new Date(Number(datepart[0]), (Number(datepart[1]) - 1), Number(datepart[2]), Number(hour), Number(timepart[1]));
    if (this.settings.ListSurcharge) {
      const surcharge = this.settings.ListSurcharge.find(obj => {
        if (obj.surcharge_end_date) {
          return datetime >= (new Date(obj.surcharge_start_date)) && datetime <= (new Date(obj.surcharge_end_date));
        } else {
          return datetime >= (new Date(obj.surcharge_start_date));
        }
      });
      if (surcharge) {
        this.servicechagePercentage = surcharge.surcharge_percentage;
        surchargeAmt = (surcharge.surcharge_percentage / 100) * amount;
      }
    }
    return surchargeAmt;
  }

  // Method to calculat the tax
  calculateTax(type, price, taxRate) {
    let taxAmount = 0;
    if (type === 'TAX_IN') {
      // Actual Price = (AmountX100)/(TaxRate+100)
      // Tax Rate = Amount -  ActualPrice
      const ActualPrice = Number(((price * 100) / (taxRate + 100)).toFixed(2));
      taxAmount = price - ActualPrice;
    } else {
      taxAmount = (taxRate / 100) * price;
    }
    return Number(taxAmount.toFixed(2));
  }

  // Method to save the dine in details to db
  saveDineIn(paymentType) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
      selectedStore.serviceQRScanned = false;
    }
    this.userSelectedStore = selectedStore;
    let dineData: any = '';
    let olarcashback = undefined;
    if (this.discountApplied) {
      olarcashback = {
        ooocd_mod_guid: this.discountApplied.mod_guid,
        amount: this.CashbackEarnedAmount.toString(),
        ooocd_mod_name: this.discountApplied.mod_name,
        ooocd_type: this.discountApplied.mod_business,
        str_percentage: this.discountApplied.mod_percentage + ''
      };
    }
    let voucherApplied = undefined;
    if (this.userSelectedStore.storeCart.voucher) {
      voucherApplied = {
        voucher_guid: this.userSelectedStore.storeCart.voucher.voucher_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.voucher.voucher_mod_guid,
        amount: this.userSelectedStore.storeCart.voucher.voucher_amount,
        ooocd_mod_name: this.userSelectedStore.storeCart.voucher.voucher_name,
        ooocd_type: this.userSelectedStore.storeCart.voucher.voucher_type
      }
    }
    if (this.referralDiscountApplied) {
      dineData = this.getDineInDataReferrals(selectedStore, this.referralCart, paymentType);

      if (olarcashback) {
        dineData.olarme_cashback_discount = olarcashback;
        dineData.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        dineData.Voucher = voucherApplied;
        dineData.string_cashback_total_amount = Number(dineData.string_cashback_total_amount) + Number(voucherApplied.amount);
      }
      let referral = {
        referral_guid: this.userSelectedStore.storeCart.referral.referral_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.referral.referral_mod_guid,
        amount: this.userSelectedStore.storeCart.referral.referral_amount,
        ooocd_mod_name: 'Referral Discount',
        ooocd_type: 'REFERRAL_DISCOUNT'
      };
      dineData.Referrals = referral;
      dineData.string_cashback_total_amount = Number(dineData.string_cashback_total_amount) + (voucherApplied ? Number(voucherApplied.amount) : 0);
      //dineData.string_cashback_total_amount = Number(dineData.string_cashback_total_amount) + (referral ? Number(referral.amount) : 0);
      //dineData.string_cashback_total_amount = Number(dineData.string_cashback_total_amount) + (olarcashback ? Number(olarcashback.amount) : 0);
    } else {
      const salesorder = {
        sales_order_status: 'DRAFT',
        order_surcharge_total: this.userSelectedStore.storeCart.orderServiceCharge.toFixed(2).toString(),
        order_gross_total: this.userSelectedStore.storeCart.orderSubTotal.toFixed(2).toString(),
        order_tax_total: this.userSelectedStore.storeCart.orderTax.toFixed(2).toString(),
        order_discount_total: '',
        order_net_total_amount: this.userSelectedStore.storeCart.orderTotal.toFixed(2).toString(),
        sales_order_location_guid: this.userSelectedStore.serviceLocationGuid,
        sales_order_id: this.getOrderID(),
        sales_order_remarks: '',
        sales_order_notes: '',
        sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
        mm_sales_order_items: [],
        mm_sales_order_surcharges: []
      };
      // check for surcharge
      if (this.settings.ListSurcharge) {
        const datetime = new Date(this.userSelectedStore.serviceDatetime);
        const surcharge = this.settings.ListSurcharge.find(obj => {
          return new Date(obj.surcharge_start_date) <= datetime && new Date(obj.surcharge_end_date) >= datetime;
        });
        if (surcharge) {
          const objsurcharge = {
            sosur_surcharge_guid: surcharge.surcharge_guid,
            sosur_surcharge_name: surcharge.surcharge_name,
            surcharge_percentage: surcharge.surcharge_percentage + '',
            surcharge_amount: this.userSelectedStore.storeCart.orderServiceCharge.toFixed(2).toString(),
          };
          salesorder.mm_sales_order_surcharges.push(objsurcharge);
        }
      }

      this.userSelectedStore.storeCart.orderItems.forEach(item => {
        // item
        const saleorderitem = {
          soi_item_guid: item.itemGuid,
          soi_item_name: item.itemName,
          mm_sales_order_items_standard_composite_variant_service_details: [],
          mm_sales_order_modifier_mapping: [],
          item_has_variant: ''
        };
        // variants
        item.variantList.forEach(variant => {
          if (variant.selected) {
            const saleorderitemvariant = {
              soiscvsd_soi_guid: item.itemGuid,
              soiscvsd_isvsd_guid: variant.variantGuid,
              soiscvsd_name: variant.variantName ? variant.variantName : '',
              soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
              price: variant.variantDineInPriceDiscounted ? variant.variantDineInPriceDiscounted.toFixed(2).toString() : variant.variantDineInPrice.toFixed(2).toString(),
              soiscvsd_tax_guid: variant.variantTaxGuid,
              tax_rate: variant.variantTaxRate.toFixed(2).toString(),
              tax_amount: variant.variantDineInTaxAmt.toFixed(2).toString(),
              quantity: variant.variantQty.toString(),
              soiscvsd_status: 'ORDERED',
              soiscvsd_notes: item.specialRequest ? item.specialRequest : '',
              discount_total_item_amount: '',
              total_amount: '',
            };
            saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
          }
        });
        saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
        // modifier set
        item.modifierSetList.forEach(set => {
          if (set.quantity > 0) {
            const modifierset = {
              somm_soi_guid: item.itemGuid,
              somm_imm_guid: set.modifiermappingGuid,
              somm_modifier_name: set.modifierName,
              mm_sales_order_modifier_mapping_options: [],
            };
            set.modifierOptions.forEach(option => {
              if (option.optionQuantity > 0) {
                const modifieroption = {
                  sommo_somm_guid: null,
                  sommo_immo_guid: option.optionGuid,
                  sommo_option_name: option.optionName,
                  sommo_tax_guid: option.optionTaxGuid,
                  tax_rate: option.optionTaxRate.toFixed(2).toString(),
                  tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                  price: option.optionPrice.toFixed(2).toString(),
                  quantity: option.optionQuantity.toFixed(2).toString(),
                  discount_total_item_amount: '',
                  total_amount: ''
                };
                modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
              }
            });
            saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
          }
        });

        salesorder.mm_sales_order_items.push(saleorderitem);
      });
      const emailBase = new EmailBase();
      emailBase.emailSubject = 'Dinein Service Confirmed';
      emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new dine in service confirmed!!<br /> Thanks.';
      emailBase.emailToMailList = [];
      // emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
      if (this.settings.oosrcs_reservation_email) {
        let emailList = this.settings.oosrcs_reservation_email.split(',');
        for (let i = 0; i < emailList.length; i++) {
          emailBase.emailToMailList.push(emailList[i]);
        }
      }

      dineData = {
        oodcdr_guid: this.userSelectedStore.serviceGuid,
        oodcdr_type: this.userSelectedStore.serviceType,
        order_date_time: this.userSelectedStore.serviceDatetime,
        oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
        oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
        oodcdr_oot_table_name: this.userSelectedStore.serviceLocationTableName,
        oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
        // oodcdr_name: this.userServiceBase.userName,
        // oodcdr_mobile: this.userServiceBase.userMobile,
        // oodcdr_country_dial_code: this.userServiceBase.userDialCode,
        oodcdr_name: this.userSelectedStore.serviceUsername,
        oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
        oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
        oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
        oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
        oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
        oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
        oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
        oodcdr_company_guid: this.settings.oosrcs_company_guid,
        oodcdr_status: 'OPEN',
        oodcdr_olar_client_id: this.webstorage.localSt_client_id,
        companyId: this.userSelectedStore.serviceCompanyId,
        oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
        string_net_total_amount: this.TotalOrderAmount.toString(),
        string_cashback_total_amount: this.CashbackEarnedAmount.toString(),
        EmailBase: {
          ToMailList: emailBase.emailToMailList,
          Subject: emailBase.emailSubject,
          Body: emailBase.emailBody
        },
        Payments: {
          amount: this.PaymentAmount.toFixed(2).toString(),
          oodcdrp_status: 'STARTED',
          oodcdrp_bank_code: 'MB2U0227',
          oodcdrp_currency: 'MYR',
          oodcdrp_transaction_description: this.serviceType,
          oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
          key_index: '1',
          payment_id: this.getPaymentId(paymentType).toString()
        },
        sales_orders: salesorder,
        Key: this.webstorage.localSt_olar_key,
        olarme_cashback_discount: null,
        Voucher: null,
        Referrals: null
      };
      if (olarcashback) {
        dineData.olarme_cashback_discount = olarcashback;
        dineData.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        dineData.Voucher = voucherApplied;
        dineData.string_cashback_total_amount = Number(dineData.string_cashback_total_amount) + (voucherApplied ? Number(voucherApplied.amount) : 0);
      }
    }

    dineData.oodcdr_mobile = this.ecomservice.encryptWithKey(dineData.oodcdr_mobile);
    dineData.oodcdr_name = this.ecomservice.encryptWithKey(dineData.oodcdr_name);
    if (dineData.oodcdr_address !== null && dineData.oodcdr_address !== undefined) {
      dineData.oodcdr_address = dineData.oodcdr_address.trim();
    }
    dineData.oodcdr_address = dineData.oodcdr_address;
    //const encryptedData = this.DineInEncryptedData(dineData);
    this.DineInPayment(paymentType, userStoreIndex, dineData, dineData.Payments);
    //this.AmBankTestPayment();
  }

  getDineInDataReferrals(storeBase: StoreServiceBase, cartBase: StoreCartBase, paymentType): any {
    const salesorder = {
      sales_order_status: 'DRAFT',
      order_surcharge_total: cartBase.orderServiceCharge.toFixed(2).toString(),
      order_gross_total: cartBase.orderSubTotal.toFixed(2).toString(),
      order_tax_total: cartBase.orderTax.toFixed(2).toString(),
      order_net_total_amount: cartBase.orderTotal.toFixed(2).toString(),
      order_discount_total: cartBase.orderDiscountReferral.toFixed(2).toString(),
      sales_order_location_guid: storeBase.serviceLocationGuid,
      sales_order_id: this.getOrderID(),
      sales_order_remarks: '',
      sales_order_notes: '',
      sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
      mm_sales_order_items: [],
      mm_sales_order_surcharges: []
    };
    // check for surcharge
    if (this.settings.ListSurcharge) {
      const datetime = new Date(storeBase.serviceDatetime);
      const surcharge = this.settings.ListSurcharge.find(obj => {
        return new Date(obj.surcharge_start_date) <= datetime && new Date(obj.surcharge_end_date) >= datetime;
      });
      if (surcharge) {
        const objsurcharge = {
          sosur_surcharge_guid: surcharge.surcharge_guid,
          sosur_surcharge_name: surcharge.surcharge_name,
          surcharge_percentage: surcharge.surcharge_percentage + '',
          surcharge_amount: cartBase.orderServiceCharge.toFixed(2).toString(),
        };
        salesorder.mm_sales_order_surcharges.push(objsurcharge);
      }
    }

    cartBase.orderItems.forEach(item => {
      // item
      const saleorderitem = {
        soi_item_guid: item.itemGuid,
        soi_item_name: item.itemName,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };
      // variants
      item.variantList.forEach(variant => {
        if (variant.selected) {
          const saleorderitemvariant = {
            soiscvsd_soi_guid: item.itemGuid,
            soiscvsd_isvsd_guid: variant.variantGuid,
            soiscvsd_name: variant.variantName ? variant.variantName : '',
            soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
            price: variant.variantSalePrice.toString(),
            soiscvsd_tax_guid: variant.variantTaxGuid,
            tax_rate: variant.variantTaxRate.toFixed(2).toString(),
            tax_amount: variant.variantTaxEach.toFixed(2).toString(),
            quantity: variant.variantQty.toString(),
            soiscvsd_status: 'ORDERED',
            soiscvsd_notes: item.specialRequest ? item.specialRequest : '',
            discount_total_item_amount: variant.totalDiscountAmount.toString(),
            total_amount: variant.totalPriceAfterDiscount.toString(),
          };
          saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
        }
      });
      saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      // modifier set
      item.modifierSetList.forEach(set => {
        if (set.quantity > 0) {
          const modifierset = {
            somm_soi_guid: item.itemGuid,
            somm_imm_guid: set.modifiermappingGuid,
            somm_modifier_name: set.modifierName,
            mm_sales_order_modifier_mapping_options: [],
          };
          set.modifierOptions.forEach(option => {
            if (option.optionQuantity > 0) {
              const modifieroption = {
                sommo_somm_guid: null,
                sommo_immo_guid: option.optionGuid,
                sommo_option_name: option.optionName,
                sommo_tax_guid: option.optionTaxGuid,
                tax_rate: option.optionTaxRate.toFixed(2).toString(),
                tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                price: option.optionSalePrice.toFixed(2).toString(),
                quantity: option.optionQuantity.toFixed(2).toString(),
                discount_total_item_amount: option.totalDiscountAmount.toFixed(2).toString(),
                total_amount: option.totalPriceAfterDiscount.toFixed(2).toString()
              };
              modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
            }
          });
          saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
        }
      });

      salesorder.mm_sales_order_items.push(saleorderitem);
    });
    const emailBase = new EmailBase();
    emailBase.emailSubject = 'Dinein Service Confirmed';
    emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new dine in service confirmed!!<br /> Thanks.';
    emailBase.emailToMailList = [];
    //emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
    if (this.settings.oosrcs_reservation_email) {
      let emailList = this.settings.oosrcs_reservation_email.split(',');
      for (let i = 0; i < emailList.length; i++) {
        emailBase.emailToMailList.push(emailList[i]);
      }
    }

    const dineData = {
      oodcdr_guid: this.userSelectedStore.serviceGuid,
      oodcdr_type: this.userSelectedStore.serviceType,
      order_date_time: this.userSelectedStore.serviceDatetime,
      oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
      oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
      oodcdr_oot_table_name: this.userSelectedStore.serviceLocationTableName,
      oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
      oodcdr_name: this.userSelectedStore.serviceUsername,
      oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
      oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
      oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
      oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
      oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
      oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
      oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: 'OPEN',
      oodcdr_olar_client_id: this.webstorage.localSt_client_id,
      companyId: this.userSelectedStore.serviceCompanyId,
      oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
      string_net_total_amount: this.TotalOrderAmount.toString(),
      string_cashback_total_amount: this.referralDiscountAmount.toString(),
      EmailBase: {
        ToMailList: emailBase.emailToMailList,
        Subject: emailBase.emailSubject,
        Body: emailBase.emailBody
      },
      Payments: {
        amount: this.PaymentAmount.toFixed(2).toString(),
        oodcdrp_status: 'STARTED',
        oodcdrp_bank_code: 'MB2U0227',
        oodcdrp_currency: 'MYR',
        oodcdrp_transaction_description: this.serviceType,
        oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
        key_index: '1',
        payment_id: this.getPaymentId(paymentType).toString()
      },
      sales_orders: salesorder,
      Key: this.webstorage.localSt_olar_key,
      olarme_cashback_discount: null,
      Voucher: null,
      Referrals: null
    };
    return dineData;
  }

  // Method to encrypt the plain data
  /*
  * commented by Harish
  * only selected fields needs to be encrypted as per the discussion
  * 
  DineInEncryptedData(plainData): any {
    const saleorderEncrypted = {
      sales_order_status: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_status),
      order_surcharge_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_surcharge_total),
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_id),
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_company_sell_prices),
      mm_sales_order_items: [],
      mm_sales_order_surcharges: []
    };
    // sale surcharges
    if (plainData.sales_orders.mm_sales_order_surcharges.length > 0) {
      plainData.sales_orders.mm_sales_order_surcharges.forEach(element => {
        const surchargeEncrypted = {
          sosur_surcharge_guid: element.sosur_surcharge_guid,
          sosur_surcharge_name: this.ecomservice.encryptWithKey(element.sosur_surcharge_name),
          surcharge_percentage: this.ecomservice.encryptWithKey(element.surcharge_percentage + ''),
          surcharge_amount: this.ecomservice.encryptWithKey(element.surcharge_amount),
        };
        saleorderEncrypted.mm_sales_order_surcharges.push(surchargeEncrypted);
      });
    }
    // sale items
    if (plainData.sales_orders.mm_sales_order_items.length > 0) {
      plainData.sales_orders.mm_sales_order_items.forEach(item => {
        // item
        const saleorderitemEncrypted = {
          soi_item_guid: item.soi_item_guid,
          soi_item_name: this.ecomservice.encryptWithKey(item.soi_item_name),
          mm_sales_order_items_standard_composite_variant_service_details: [],
          mm_sales_order_modifier_mapping: [],
          item_has_variant: ''
        };

        // variants
        item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {

          const saleorderitemvariantEncrypted = {
            soiscvsd_soi_guid: item.soi_item_guid,
            soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
            soiscvsd_name: variant.soiscvsd_name ? this.ecomservice.encryptWithKey(variant.soiscvsd_name) : '',
            soiscvsd_sku: this.ecomservice.encryptWithKey(variant.soiscvsd_sku),
            price: this.ecomservice.encryptWithKey(variant.price),
            soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
            quantity: this.ecomservice.encryptWithKey(variant.quantity),
            soiscvsd_status: this.ecomservice.encryptWithKey(variant.soiscvsd_status),
            soiscvsd_notes: variant.soiscvsd_notes ? this.ecomservice.encryptWithKey(variant.soiscvsd_notes) : '',
            discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
            total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
          };

          saleorderitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariantEncrypted);

        });
        saleorderitemEncrypted.item_has_variant = this.ecomservice.encryptWithKey(saleorderitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false');

        // modifier set
        item.mm_sales_order_modifier_mapping.forEach(set => {
          const modifiersetEncrypted = {
            somm_soi_guid: item.soi_item_guid,
            somm_imm_guid: set.somm_imm_guid,
            somm_modifier_name: this.ecomservice.encryptWithKey(set.somm_modifier_name),
            mm_sales_order_modifier_mapping_options: [],
          };
          // modifier options
          set.mm_sales_order_modifier_mapping_options.forEach(option => {
            if (option.quantity > 0) {
              const modifieroptionEncrypted = {
                sommo_immo_guid: option.sommo_immo_guid,
                sommo_option_name: this.ecomservice.encryptWithKey(option.sommo_option_name),
                sommo_tax_guid: option.sommo_tax_guid,
                tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
                tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
                price: this.ecomservice.encryptWithKey(option.price),
                quantity: this.ecomservice.encryptWithKey(option.quantity),
                discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
                total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
              };
              modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
            }
          });
          saleorderitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
        });
        saleorderEncrypted.mm_sales_order_items.push(saleorderitemEncrypted);
      });
    }
    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });

    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_mod_name),
        ooocd_type: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_type),
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }
    const dineDataencrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: this.ecomservice.encryptWithKey(plainData.oodcdr_type),
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_oot_table_name: this.ecomservice.encryptWithKey(plainData.oodcdr_oot_table_name),
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests && plainData.oodcdr_special_requests.length > 1 ? this.ecomservice.encryptWithKey(plainData.oodcdr_special_requests) : '',
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: this.ecomservice.encryptWithKey(plainData.oodcdr_status),
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: this.ecomservice.encryptWithKey(plainData.companyId),
      oodcdr_is_qrcodescan: plainData.oodcdr_is_qrcodescan,
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: this.ecomservice.encryptWithKey(plainData.EmailBase.Subject),
        Body: this.ecomservice.encryptWithKey(plainData.EmailBase.Body)
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_status),
        oodcdrp_bank_code: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_bank_code),
        oodcdrp_currency: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_currency),
        oodcdrp_transaction_description: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_transaction_description),
        oodcdrp_ipaddress: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_ipaddress),
        key_index: this.ecomservice.encryptWithKey(plainData.Payments.key_index),
        payment_id: this.ecomservice.encryptWithKey(plainData.Payments.payment_id)
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      dineDataencrypted.olarme_cashback_discount = cashbackencrypted;
    }
    return dineDataencrypted;
  }
  */

  DineInEncryptedData(plainData): any {
    const saleorderEncrypted = {
      sales_order_status: plainData.sales_orders.sales_order_status,
      order_surcharge_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_surcharge_total),
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: plainData.sales_orders.sales_order_id,
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: plainData.sales_orders.sales_order_company_sell_prices,
      mm_sales_order_items: [],
      mm_sales_order_surcharges: []
    };
    // sale surcharges
    if (plainData.sales_orders.mm_sales_order_surcharges.length > 0) {
      plainData.sales_orders.mm_sales_order_surcharges.forEach(element => {
        const surchargeEncrypted = {
          sosur_surcharge_guid: element.sosur_surcharge_guid,
          sosur_surcharge_name: element.sosur_surcharge_name,
          surcharge_percentage: this.ecomservice.encryptWithKey(element.surcharge_percentage + ''),
          surcharge_amount: this.ecomservice.encryptWithKey(element.surcharge_amount),
        };
        saleorderEncrypted.mm_sales_order_surcharges.push(surchargeEncrypted);
      });
    }
    // sale items
    if (plainData.sales_orders.mm_sales_order_items.length > 0) {
      plainData.sales_orders.mm_sales_order_items.forEach(item => {
        // item
        const saleorderitemEncrypted = {
          soi_item_guid: item.soi_item_guid,
          soi_item_name: item.soi_item_name,
          mm_sales_order_items_standard_composite_variant_service_details: [],
          mm_sales_order_modifier_mapping: [],
          item_has_variant: ''
        };

        // variants
        item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {

          const saleorderitemvariantEncrypted = {
            soiscvsd_soi_guid: item.soi_item_guid,
            soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
            soiscvsd_name: variant.soiscvsd_name,
            soiscvsd_sku: variant.soiscvsd_sku,
            price: this.ecomservice.encryptWithKey(variant.price),
            soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
            quantity: this.ecomservice.encryptWithKey(variant.quantity),
            soiscvsd_status: variant.soiscvsd_status,
            soiscvsd_notes: variant.soiscvsd_notes,
            discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
            total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
          };

          saleorderitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariantEncrypted);

        });
        saleorderitemEncrypted.item_has_variant = saleorderitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';

        // modifier set
        item.mm_sales_order_modifier_mapping.forEach(set => {
          const modifiersetEncrypted = {
            somm_soi_guid: item.soi_item_guid,
            somm_imm_guid: set.somm_imm_guid,
            somm_modifier_name: set.somm_modifier_name,
            mm_sales_order_modifier_mapping_options: [],
          };
          // modifier options
          set.mm_sales_order_modifier_mapping_options.forEach(option => {
            if (option.quantity > 0) {
              const modifieroptionEncrypted = {
                sommo_immo_guid: option.sommo_immo_guid,
                sommo_option_name: option.sommo_option_name,
                sommo_tax_guid: option.sommo_tax_guid,
                tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
                tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
                price: this.ecomservice.encryptWithKey(option.price),
                quantity: this.ecomservice.encryptWithKey(option.quantity),
                discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
                total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
              };
              modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
            }
          });
          saleorderitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
        });
        saleorderEncrypted.mm_sales_order_items.push(saleorderitemEncrypted);
      });
    }
    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });

    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: plainData.olarme_cashback_discount.ooocd_mod_name,
        ooocd_type: plainData.olarme_cashback_discount.ooocd_type,
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }
    const dineDataencrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: plainData.oodcdr_type,
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_oot_table_name: plainData.oodcdr_oot_table_name,
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests,
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: plainData.oodcdr_status,
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: plainData.companyId,
      oodcdr_is_qrcodescan: plainData.oodcdr_is_qrcodescan,
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: plainData.EmailBase.Subject,
        Body: plainData.EmailBase.Body
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: plainData.Payments.oodcdrp_status,
        oodcdrp_bank_code: plainData.Payments.oodcdrp_bank_code,
        oodcdrp_currency: plainData.Payments.oodcdrp_currency,
        oodcdrp_transaction_description: plainData.Payments.oodcdrp_transaction_description,
        oodcdrp_ipaddress: plainData.Payments.oodcdrp_ipaddress,
        key_index: plainData.Payments.key_index,
        payment_id: plainData.Payments.payment_id
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      dineDataencrypted.olarme_cashback_discount = cashbackencrypted;
    }
    return dineDataencrypted;
  }

  AmBankTestPayment() {
    const order = new orderDetails();
    order.Amount = this.PaymentAmount,
      order.Customer_Name = this.userServiceBase.userName;
    order.Customer_Email = this.userServiceBase.userEmail;
    order.Customer_Contact = this.userServiceBase.userMobile;
    order.Customer_IP = this.webstorage.localSt_ip;
    this.AmBankPaymentRequest(order);
  }

  // Method to make the dinein payment
  DineInPayment(paymentType, userStoreIndex, dineInEncrypted, paymentDetails) {
    this.retrycount = this.retrycount + 1;
    this.ecomservice.httpPost(EcomNetworkUtils.POST_ADD_SERVICE, dineInEncrypted, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.status === 200) {
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceGuid = response.value;
          this.webstorage.localSt_user_service_request = this.userServiceBase;

          this.webstorage.sessionSt_frompage = 'payment';
          if (paymentType !== 'Reserved') {
            const referencenumber = response.listValue.ooco_payment_reference;
            const order = new orderDetails();
            order.PaymentType = paymentType;
            order.Reference_Number = referencenumber;
            order.Amount = this.PaymentAmount,
              order.Currency = paymentDetails.oodcdrp_currency,
              order.Transaction_Description = paymentDetails.oodcdrp_transaction_description;
            order.Customer_Name = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUsername;
            order.Customer_Email = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserEmail;
            order.Customer_Contact = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserMobilenumber;
            order.Customer_IP = this.webstorage.localSt_ip;
            this.sendPaymentRequest(order);

          } else {
            // cash on delevery or pay at counter
            this.router.navigate(['status-dinein'], { queryParams: { companyId: this.userSelectedStore.serviceCompanyId, serviceId: response.value } });
          }
        } else {
          if (this.retrycount < 3) {
            this.saveDineIn(paymentType);
          } else {
            this.alerts = [];
            this.alerts.push({
              type: 'warning',
              msg: 'currently not able to proceed try after sometimes!',
              timeout: 5000,
              isOpen: true
            });
          }
        }
      }
    });
  }

  // Method to handle the collection data save to db
  saveCollection(paymentType) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
      selectedStore.serviceQRScanned = false;
    }
    this.userSelectedStore = selectedStore;

    let collectionData: any = '';
    let olarcashback = undefined;
    if (this.discountApplied) {
      olarcashback = {
        ooocd_mod_guid: this.discountApplied.mod_guid,
        amount: this.CashbackEarnedAmount.toString(),
        ooocd_mod_name: this.discountApplied.mod_name,
        ooocd_type: this.discountApplied.mod_business,
        str_percentage: this.discountApplied.mod_percentage + ''
      };
    }
    let voucherApplied = undefined;
    if (this.userSelectedStore.storeCart.voucher) {
      voucherApplied = {
        voucher_guid: this.userSelectedStore.storeCart.voucher.voucher_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.voucher.voucher_mod_guid,
        amount: this.userSelectedStore.storeCart.voucher.voucher_amount,
        ooocd_mod_name: this.userSelectedStore.storeCart.voucher.voucher_name,
        ooocd_type: this.userSelectedStore.storeCart.voucher.voucher_type
      }
    }

    if (this.referralDiscountApplied) {
      collectionData = this.getCollectionDataReferrals(selectedStore, this.referralCart, paymentType);
      if (olarcashback) {
        collectionData.olarme_cashback_discount = olarcashback;
        collectionData.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        collectionData.Voucher = voucherApplied;
        collectionData.string_cashback_total_amount = Number(collectionData.string_cashback_total_amount) + Number(voucherApplied.amount);
      }
      let referral = {
        referral_guid: this.userSelectedStore.storeCart.referral.referral_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.referral.referral_mod_guid,
        amount: this.userSelectedStore.storeCart.referral.referral_amount,
        ooocd_mod_name: 'Referral Discount',
        ooocd_type: 'REFERRAL_DISCOUNT'
      };
      collectionData.Referrals = referral;
      collectionData.string_cashback_total_amount = Number(collectionData.string_cashback_total_amount) + (voucherApplied ? Number(voucherApplied.amount) : 0);
      //collectionData.string_cashback_total_amount = Number(collectionData.string_cashback_total_amount) + (referral ? Number(referral.amount) : 0);
      //collectionData.string_cashback_total_amount = Number(collectionData.string_cashback_total_amount) + (olarcashback ? Number(olarcashback.amount) : 0);
    } else {
      const salesorder = {
        sales_order_status: 'DRAFT',
        order_gross_total: this.userSelectedStore.storeCart.orderSubTotal.toFixed(2).toString(),
        order_tax_total: this.userSelectedStore.storeCart.orderTax.toFixed(2).toString(),
        order_net_total_amount: this.userSelectedStore.storeCart.orderTotal.toFixed(2).toString(),
        sales_order_location_guid: this.userSelectedStore.serviceLocationGuid,
        sales_order_id: this.getOrderID(),
        sales_order_remarks: '',
        sales_order_notes: '',
        sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
        mm_sales_order_items: []
      };
      this.userSelectedStore.storeCart.orderItems.forEach(item => {
        // item
        const saleorderitem = {
          soi_item_guid: item.itemGuid,
          soi_item_name: item.itemName,
          mm_sales_order_items_standard_composite_variant_service_details: [],
          mm_sales_order_modifier_mapping: [],
          item_has_variant: ''
        };
        // variants
        item.variantList.forEach(variant => {
          if (variant.selected) {
            const saleorderitemvariant = {
              soiscvsd_soi_guid: item.itemGuid,
              soiscvsd_isvsd_guid: variant.variantGuid,
              soiscvsd_name: variant.variantName ? variant.variantName : '',
              soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
              price: variant.variantCollectionPriceDiscounted ? variant.variantCollectionPriceDiscounted.toFixed(2).toString() : variant.variantDeliveryCollectionPrice.toFixed(2).toString(),
              soiscvsd_tax_guid: variant.variantTaxGuid,
              tax_rate: variant.variantTaxRate.toFixed(2).toString(),
              tax_amount: variant.variantDeliveryTaxAmt.toFixed(2).toString(),
              quantity: variant.variantQty.toFixed(2).toString(),
              soiscvsd_status: 'ORDERED',
              soiscvsd_notes: item.specialRequest ? item.specialRequest : ''
            };
            saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
          }
        });
        saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';

        // modifier set
        item.modifierSetList.forEach(set => {
          if (set.quantity > 0) {
            const modifierset = {
              somm_soi_guid: item.itemGuid,
              somm_imm_guid: set.modifiermappingGuid,
              somm_modifier_name: set.modifierName,
              mm_sales_order_modifier_mapping_options: [],
            };
            set.modifierOptions.forEach(option => {
              if (option.optionQuantity > 0) {
                const modifieroption = {
                  sommo_somm_guid: null,
                  sommo_immo_guid: option.optionGuid,
                  sommo_option_name: option.optionName,
                  sommo_tax_guid: option.optionTaxGuid,
                  tax_rate: option.optionTaxRate.toFixed(2).toString(),
                  tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                  price: option.optionPrice.toFixed(2).toString(),
                  quantity: option.optionQuantity.toFixed(2).toString(),
                };
                modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
              }
            });
            saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
          }
        });

        salesorder.mm_sales_order_items.push(saleorderitem);
      });

      const emailBase = new EmailBase();
      emailBase.emailSubject = 'Collection Service Confirmed';
      emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new collection service confirmed!!<br /> Thanks.';
      emailBase.emailToMailList = [];
      // emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
      if (this.settings.oosrcs_reservation_email) {
        let emailList = this.settings.oosrcs_reservation_email.split(',');
        for (let i = 0; i < emailList.length; i++) {
          emailBase.emailToMailList.push(emailList[i]);
        }
      }

      collectionData = {
        oodcdr_guid: this.userSelectedStore.serviceGuid,
        oodcdr_type: this.userSelectedStore.serviceType,
        order_date_time: this.userSelectedStore.serviceDatetime,
        oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
        oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
        oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
        // oodcdr_name: this.userServiceBase.userName,
        // oodcdr_mobile: this.userServiceBase.userMobile,
        // oodcdr_country_dial_code: this.userServiceBase.userDialCode,
        oodcdr_name: this.userSelectedStore.serviceUsername,
        oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
        oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
        oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
        oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
        oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
        oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
        oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
        oodcdr_company_guid: this.settings.oosrcs_company_guid,
        oodcdr_status: 'OPEN',
        oodcdr_olar_client_id: this.webstorage.localSt_client_id,
        companyId: this.userSelectedStore.serviceCompanyId,
        oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
        string_net_total_amount: this.TotalOrderAmount.toString(),
        string_cashback_total_amount: this.CashbackEarnedAmount.toString(),
        EmailBase: {
          ToMailList: emailBase.emailToMailList,
          Subject: emailBase.emailSubject,
          Body: emailBase.emailBody
        },
        Payments: {
          amount: this.PaymentAmount.toFixed(2).toString(),
          oodcdrp_status: 'STARTED',
          oodcdrp_bank_code: 'MB2U0227',
          oodcdrp_currency: 'MYR',
          oodcdrp_transaction_description: this.serviceType,
          oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
          key_index: '1',
          payment_id: this.getPaymentId(paymentType).toString()
        },
        sales_orders: salesorder,
        Key: this.webstorage.localSt_olar_key,
        olarme_cashback_discount: null,
        Voucher: null,
        Referrals: null
      };
      if (olarcashback) {
        collectionData.olarme_cashback_discount = olarcashback;
        collectionData.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        collectionData.Voucher = voucherApplied;
        collectionData.string_cashback_total_amount = Number(collectionData.string_cashback_total_amount) + Number(voucherApplied.amount);
      }
    }
    collectionData.oodcdr_mobile = this.ecomservice.encryptWithKey(collectionData.oodcdr_mobile);
    collectionData.oodcdr_name = this.ecomservice.encryptWithKey(collectionData.oodcdr_name);
    if (collectionData.oodcdr_address !== null && collectionData.oodcdr_address !== undefined) {
      collectionData.oodcdr_address = collectionData.oodcdr_address.trim();
    }
    collectionData.oodcdr_address = collectionData.oodcdr_address;
    this.CollectionPayment(paymentType, userStoreIndex, collectionData, collectionData.Payments);
  }

  getCollectionDataReferrals(storeBase: StoreServiceBase, cartBase: StoreCartBase, paymentType): any {
    const salesorder = {
      sales_order_status: 'DRAFT',
      order_gross_total: cartBase.orderSubTotal.toFixed(2).toString(),
      order_tax_total: cartBase.orderTax.toFixed(2).toString(),
      order_net_total_amount: cartBase.orderTotal.toFixed(2).toString(),
      order_discount_total: cartBase.orderDiscountReferral.toFixed(2).toString(),
      sales_order_location_guid: storeBase.serviceLocationGuid,
      sales_order_id: this.getOrderID(),
      sales_order_remarks: '',
      sales_order_notes: '',
      sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
      mm_sales_order_items: [],
      mm_sales_order_surcharges: []
    };


    cartBase.orderItems.forEach(item => {
      // item
      const saleorderitem = {
        soi_item_guid: item.itemGuid,
        soi_item_name: item.itemName,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };
      // variants
      item.variantList.forEach(variant => {
        if (variant.selected) {
          const saleorderitemvariant = {
            soiscvsd_soi_guid: item.itemGuid,
            soiscvsd_isvsd_guid: variant.variantGuid,
            soiscvsd_name: variant.variantName ? variant.variantName : '',
            soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
            price: variant.variantSalePrice.toString(),
            soiscvsd_tax_guid: variant.variantTaxGuid,
            tax_rate: variant.variantTaxRate.toFixed(2).toString(),
            tax_amount: variant.variantTaxEach.toFixed(2).toString(),
            quantity: variant.variantQty.toString(),
            soiscvsd_status: 'ORDERED',
            soiscvsd_notes: item.specialRequest ? item.specialRequest : '',
            discount_total_item_amount: variant.totalDiscountAmount.toString(),
            total_amount: variant.totalPriceAfterDiscount.toString(),
          };
          saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
        }
      });
      saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      // modifier set
      item.modifierSetList.forEach(set => {
        if (set.quantity > 0) {
          const modifierset = {
            somm_soi_guid: item.itemGuid,
            somm_imm_guid: set.modifiermappingGuid,
            somm_modifier_name: set.modifierName,
            mm_sales_order_modifier_mapping_options: [],
          };
          set.modifierOptions.forEach(option => {
            if (option.optionQuantity > 0) {
              const modifieroption = {
                sommo_somm_guid: null,
                sommo_immo_guid: option.optionGuid,
                sommo_option_name: option.optionName,
                sommo_tax_guid: option.optionTaxGuid,
                tax_rate: option.optionTaxRate.toFixed(2).toString(),
                tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                price: option.optionSalePrice.toFixed(2).toString(),
                quantity: option.optionQuantity.toFixed(2).toString(),
                discount_total_item_amount: option.totalDiscountAmount.toFixed(2).toString(),
                total_amount: option.totalPriceAfterDiscount.toFixed(2).toString()
              };
              modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
            }
          });
          saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
        }
      });

      salesorder.mm_sales_order_items.push(saleorderitem);
    });
    const emailBase = new EmailBase();
    emailBase.emailSubject = 'Collection Service Confirmed';
    emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new collection service confirmed!!<br /> Thanks.';
    emailBase.emailToMailList = [];
    // emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
    if (this.settings.oosrcs_reservation_email) {
      let emailList = this.settings.oosrcs_reservation_email.split(',');
      for (let i = 0; i < emailList.length; i++) {
        emailBase.emailToMailList.push(emailList[i]);
      }
    }
    const collectionData = {
      oodcdr_guid: this.userSelectedStore.serviceGuid,
      oodcdr_type: this.userSelectedStore.serviceType,
      order_date_time: this.userSelectedStore.serviceDatetime,
      oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
      oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
      oodcdr_oot_table_name: this.userSelectedStore.serviceLocationTableName,
      oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
      oodcdr_name: this.userSelectedStore.serviceUsername,
      oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
      oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
      oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
      oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
      oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
      oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
      oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: 'OPEN',
      oodcdr_olar_client_id: this.webstorage.localSt_client_id,
      companyId: this.userSelectedStore.serviceCompanyId,
      oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
      string_net_total_amount: this.TotalOrderAmount.toString(),
      string_cashback_total_amount: this.referralDiscountAmount.toString(),
      EmailBase: {
        ToMailList: emailBase.emailToMailList,
        Subject: emailBase.emailSubject,
        Body: emailBase.emailBody
      },
      Payments: {
        amount: this.PaymentAmount.toFixed(2).toString(),
        oodcdrp_status: 'STARTED',
        oodcdrp_bank_code: 'MB2U0227',
        oodcdrp_currency: 'MYR',
        oodcdrp_transaction_description: this.serviceType,
        oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
        key_index: '1',
        payment_id: this.getPaymentId(paymentType).toString()
      },
      sales_orders: salesorder,
      Key: this.webstorage.localSt_olar_key,
      olarme_cashback_discount: null,
      Voucher: null,
      Referrals: null
    };
    return collectionData;
  }

  // Method to encrypt the plain data
  /*
  *
  *
  CollectionEncryptedData(plainData): any {

    const saleorderEncrypted = {
      sales_order_status: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_status),
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_id),
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_company_sell_prices),
      mm_sales_order_items: []
    };

    //saleitems
    plainData.sales_orders.mm_sales_order_items.forEach(item => {

      const saleitemEncrypted = {
        soi_item_guid: item.soi_item_guid,
        soi_item_name: this.ecomservice.encryptWithKey(item.soi_item_name),
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };

      // variants
      item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
        const variantEncrypted = {
          soiscvsd_soi_guid: item.soi_item_guid,
          soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
          soiscvsd_name: variant.soiscvsd_name ? this.ecomservice.encryptWithKey(variant.soiscvsd_name) : '',
          soiscvsd_sku: this.ecomservice.encryptWithKey(variant.soiscvsd_sku),
          price: this.ecomservice.encryptWithKey(variant.price),
          soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
          tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
          tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
          quantity: this.ecomservice.encryptWithKey(variant.quantity),
          soiscvsd_status: this.ecomservice.encryptWithKey(variant.soiscvsd_status),
          soiscvsd_notes: variant.soiscvsd_notes ? this.ecomservice.encryptWithKey(variant.soiscvsd_notes) : '',
          discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
          total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
        };
        saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(variantEncrypted);
      });

      //modifiers
      item.mm_sales_order_modifier_mapping.forEach(set => {
        const modifiersetEncrypted = {
          somm_soi_guid: set.somm_soi_guid,
          somm_imm_guid: set.somm_imm_guid,
          somm_modifier_name: this.ecomservice.encryptWithKey(set.somm_modifier_name),
          mm_sales_order_modifier_mapping_options: [],
        };

        //options
        set.mm_sales_order_modifier_mapping_options.forEach(option => {
          const modifieroptionEncrypted = {
            sommo_immo_guid: option.sommo_immo_guid,
            sommo_option_name: this.ecomservice.encryptWithKey(option.sommo_option_name),
            sommo_tax_guid: option.sommo_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
            price: this.ecomservice.encryptWithKey(option.price),
            quantity: this.ecomservice.encryptWithKey(option.quantity),
            discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
            total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
          };
          modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
        });
        saleitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
      });

      saleitemEncrypted.item_has_variant = this.ecomservice.encryptWithKey(saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false');
      saleorderEncrypted.mm_sales_order_items.push(saleitemEncrypted);
    });

    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });

    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_mod_name),
        ooocd_type: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_type),
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }

    const collectionDataEncrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: this.ecomservice.encryptWithKey(plainData.oodcdr_type),
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests && plainData.oodcdr_special_requests.length > 1 ? this.ecomservice.encryptWithKey(plainData.oodcdr_special_requests) : '',
      oodcdr_company_guid: plainData.oodcdr_company_guid,
      oodcdr_status: this.ecomservice.encryptWithKey(plainData.oodcdr_status),
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: this.ecomservice.encryptWithKey(plainData.companyId),
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: this.ecomservice.encryptWithKey(plainData.EmailBase.Subject),
        Body: this.ecomservice.encryptWithKey(plainData.EmailBase.Body)
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_status),
        oodcdrp_bank_code: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_bank_code),
        oodcdrp_currency: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_currency),
        oodcdrp_transaction_description: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_transaction_description),
        oodcdrp_ipaddress: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_ipaddress),
        key_index: this.ecomservice.encryptWithKey(plainData.Payments.key_index),
        payment_id: this.ecomservice.encryptWithKey(plainData.Payments.payment_id)
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      collectionDataEncrypted.olarme_cashback_discount = cashbackencrypted;
    }
    return collectionDataEncrypted;
  }
  */

  CollectionEncryptedData(plainData): any {

    const saleorderEncrypted = {
      sales_order_status: plainData.sales_orders.sales_order_status,
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: plainData.sales_orders.sales_order_id,
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: plainData.sales_orders.sales_order_company_sell_prices,
      mm_sales_order_items: []
    };

    //saleitems
    plainData.sales_orders.mm_sales_order_items.forEach(item => {

      const saleitemEncrypted = {
        soi_item_guid: item.soi_item_guid,
        soi_item_name: item.soi_item_name,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };

      // variants
      item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
        const variantEncrypted = {
          soiscvsd_soi_guid: item.soi_item_guid,
          soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
          soiscvsd_name: variant.soiscvsd_name,
          soiscvsd_sku: variant.soiscvsd_sku,
          price: this.ecomservice.encryptWithKey(variant.price),
          soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
          tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
          tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
          quantity: this.ecomservice.encryptWithKey(variant.quantity),
          soiscvsd_status: variant.soiscvsd_status,
          soiscvsd_notes: variant.soiscvsd_notes,
          discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
          total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
        };
        saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(variantEncrypted);
      });

      //modifiers
      item.mm_sales_order_modifier_mapping.forEach(set => {
        const modifiersetEncrypted = {
          somm_soi_guid: set.somm_soi_guid,
          somm_imm_guid: set.somm_imm_guid,
          somm_modifier_name: set.somm_modifier_name,
          mm_sales_order_modifier_mapping_options: [],
        };

        //options
        set.mm_sales_order_modifier_mapping_options.forEach(option => {
          const modifieroptionEncrypted = {
            sommo_immo_guid: option.sommo_immo_guid,
            sommo_option_name: option.sommo_option_name,
            sommo_tax_guid: option.sommo_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
            price: this.ecomservice.encryptWithKey(option.price),
            quantity: this.ecomservice.encryptWithKey(option.quantity),
            discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
            total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
          };
          modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
        });
        saleitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
      });

      saleitemEncrypted.item_has_variant = saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      saleorderEncrypted.mm_sales_order_items.push(saleitemEncrypted);
    });

    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });

    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: plainData.olarme_cashback_discount.ooocd_mod_name,
        ooocd_type: plainData.olarme_cashback_discount.ooocd_type,
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }

    const collectionDataEncrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: plainData.oodcdr_type,
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests,
      oodcdr_company_guid: plainData.oodcdr_company_guid,
      oodcdr_status: plainData.oodcdr_status,
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: plainData.companyId,
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: plainData.EmailBase.Subject,
        Body: plainData.EmailBase.Body
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: plainData.Payments.oodcdrp_status,
        oodcdrp_bank_code: plainData.Payments.oodcdrp_bank_code,
        oodcdrp_currency: plainData.Payments.oodcdrp_currency,
        oodcdrp_transaction_description: plainData.Payments.oodcdrp_transaction_description,
        oodcdrp_ipaddress: plainData.Payments.oodcdrp_ipaddress,
        key_index: plainData.Payments.key_index,
        payment_id: plainData.Payments.payment_id
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      collectionDataEncrypted.olarme_cashback_discount = cashbackencrypted;
    }
    return collectionDataEncrypted;
  }

  // Method to make the payment
  CollectionPayment(paymentType, userStoreIndex, collectionEncrypted, paymentDetails) {
    this.retrycount = this.retrycount + 1;
    this.ecomservice.httpPost(EcomNetworkUtils.POST_ADD_SERVICE, collectionEncrypted, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.status === 200) {
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceGuid = response.value;
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          this.webstorage.sessionSt_frompage = 'payment';
          if (paymentType !== 'Reserved') {
            const referencenumber = response.listValue.ooco_payment_reference;
            const order = new orderDetails();
            order.PaymentType = paymentType;
            order.Reference_Number = referencenumber;
            order.Amount = this.PaymentAmount,
              order.Currency = paymentDetails.oodcdrp_currency,
              order.Transaction_Description = paymentDetails.oodcdrp_transaction_description;
            order.Customer_Name = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUsername;
            order.Customer_Email = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserEmail;
            order.Customer_Contact = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserMobilenumber;
            order.Customer_IP = this.webstorage.localSt_ip;
            this.sendPaymentRequest(order);
          } else {
            this.router.navigate(['status-collection'], { queryParams: { companyId: this.userSelectedStore.serviceCompanyId, serviceId: response.value } });
          }
        } else {
          if (this.retrycount < 3) {
            this.saveCollection(paymentType);
          } else {
            this.alerts = [];
            this.alerts.push({
              type: 'warning',
              msg: 'currently not able to proceed try after sometimes!',
              timeout: 5000,
              isOpen: true
            });
          }
        }
      }
    });
  }

  // Method to save the delivery data to db
  saveDelivery(paymentType) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
      selectedStore.serviceQRScanned = false;
    }
    this.userSelectedStore = selectedStore;
    let deliverydata: any = '';
    let olarcashback = undefined;
    if (this.discountApplied) {
      olarcashback = {
        ooocd_mod_guid: this.discountApplied.mod_guid,
        amount: this.CashbackEarnedAmount.toString(),
        ooocd_mod_name: this.discountApplied.mod_name,
        ooocd_type: this.discountApplied.mod_business,
        str_percentage: this.discountApplied.mod_percentage + ''
      };
    }
    let voucherApplied = undefined;
    if (this.userSelectedStore.storeCart.voucher) {
      voucherApplied = {
        voucher_guid: this.userSelectedStore.storeCart.voucher.voucher_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.voucher.voucher_mod_guid,
        amount: this.userSelectedStore.storeCart.voucher.voucher_amount,
        ooocd_mod_name: this.userSelectedStore.storeCart.voucher.voucher_name,
        ooocd_type: this.userSelectedStore.storeCart.voucher.voucher_type
      }
    }

    if (this.referralDiscountApplied) {
      deliverydata = this.getDeliveryDataReferrals(selectedStore, this.referralCart, paymentType);
      if (olarcashback) {
        deliverydata.olarme_cashback_discount = olarcashback;
        deliverydata.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        deliverydata.Voucher = voucherApplied;
        deliverydata.string_cashback_total_amount = Number(deliverydata.string_cashback_total_amount) + Number(voucherApplied.amount);
      }
      let referral = {
        referral_guid: this.userSelectedStore.storeCart.referral.referral_guid,
        ooocd_mod_guid: this.userSelectedStore.storeCart.referral.referral_mod_guid,
        amount: this.userSelectedStore.storeCart.referral.referral_amount,
        ooocd_mod_name: 'Referral Discount',
        ooocd_type: 'REFERRAL_DISCOUNT'
      };
      deliverydata.Referrals = referral;
      deliverydata.string_cashback_total_amount = Number(deliverydata.string_cashback_total_amount) + (voucherApplied ? Number(voucherApplied.amount) : 0);
      //deliverydata.string_cashback_total_amount = Number(deliverydata.string_cashback_total_amount) + (referral ? Number(referral.amount) : 0);
      //deliverydata.string_cashback_total_amount = Number(deliverydata.string_cashback_total_amount) + (olarcashback ? Number(olarcashback.amount) : 0);

    } else {
      const salesorder = {
        sales_order_status: 'DRAFT',
        //sales_order_delivery_charge_total: this.userSelectedStore.storeCart.orderDeliveryCharge,
        delivery_charge_total: this.userSelectedStore.storeCart.orderDeliveryCharge.toFixed(2).toString(),
        order_gross_total: this.userSelectedStore.storeCart.orderSubTotal.toFixed(2).toString(),
        order_tax_total: this.userSelectedStore.storeCart.orderTax.toFixed(2).toString(),
        order_net_total_amount: this.userSelectedStore.storeCart.orderTotal.toFixed(2).toString(),
        sales_order_location_guid: this.userSelectedStore.serviceLocationGuid,
        sales_order_id: this.getOrderID(),
        sales_order_remarks: '',
        sales_order_notes: '',
        sales_order_company_sell_prices: this.settings.company_sell_price_tax,
        mm_sales_order_items: []
      };
      this.userSelectedStore.storeCart.orderItems.forEach(item => {
        // item
        const saleorderitem = {
          soi_item_guid: item.itemGuid,
          soi_item_name: item.itemName,
          mm_sales_order_items_standard_composite_variant_service_details: [],
          mm_sales_order_modifier_mapping: [],
          item_has_variant: ''
        };
        // variants
        item.variantList.forEach(variant => {
          if (variant.selected) {
            const saleorderitemvariant = {
              soiscvsd_soi_guid: item.itemGuid,
              soiscvsd_isvsd_guid: variant.variantGuid,
              soiscvsd_name: variant.variantName ? variant.variantName : '',
              soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
              price: variant.variantDeliveryPriceDiscounted ? variant.variantDeliveryPriceDiscounted.toFixed(2).toString() : variant.variantDeliveryCollectionPrice.toFixed(2).toString(),
              soiscvsd_tax_guid: variant.variantTaxGuid,
              tax_rate: variant.variantTaxRate.toFixed(2).toString(),
              tax_amount: variant.variantDeliveryTaxAmt.toFixed(2).toString(),
              quantity: variant.variantQty.toFixed(2).toString(),
              soiscvsd_status: 'ORDERED',
              soiscvsd_notes: item.specialRequest ? item.specialRequest : ''
            };
            saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
          }
        });
        saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';

        // modifier set
        item.modifierSetList.forEach(set => {
          if (set.quantity > 0) {
            const modifierset = {
              somm_soi_guid: item.itemGuid,
              somm_imm_guid: set.modifiermappingGuid,
              somm_modifier_name: set.modifierName,
              mm_sales_order_modifier_mapping_options: [],
            };
            set.modifierOptions.forEach(option => {
              if (option.optionQuantity > 0) {
                const modifieroption = {
                  sommo_somm_guid: null,
                  sommo_immo_guid: option.optionGuid,
                  sommo_option_name: option.optionName,
                  sommo_tax_guid: option.optionTaxGuid,
                  tax_rate: option.optionTaxRate.toFixed(2).toString(),
                  tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                  price: option.optionPrice.toFixed(2).toString(),
                  quantity: option.optionQuantity.toFixed(2).toString(),
                };
                modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
              }
            });
            saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
          }
        });

        salesorder.mm_sales_order_items.push(saleorderitem);
      });

      const emailBase = new EmailBase();
      emailBase.emailSubject = 'Delivery Service Confirmed';
      emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new delivery service confirmed!!<br /> Thanks.';
      emailBase.emailToMailList = [];
      //emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
      if (this.settings.oosrcs_reservation_email) {
        let emailList = this.settings.oosrcs_reservation_email.split(',');
        for (let i = 0; i < emailList.length; i++) {
          emailBase.emailToMailList.push(emailList[i]);
        }
      }

      deliverydata = {
        oodcdr_guid: this.userSelectedStore.serviceGuid,
        oodcdr_type: this.userSelectedStore.serviceType,
        order_date_time: this.userSelectedStore.serviceDatetime,
        oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
        oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
        oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
        // oodcdr_name: this.userServiceBase.userName,
        // oodcdr_mobile: this.userServiceBase.userMobile,
        // oodcdr_country_dial_code: this.userServiceBase.userDialCode,
        oodcdr_name: this.userSelectedStore.serviceUsername,
        oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
        oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
        oodcdr_address: this.userServiceBase.userMapAddress ? this.userServiceBase.userMapAddress : '',
        oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
        oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
        oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
        oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
        oodcdr_company_guid: this.settings.oosrcs_company_guid,
        oodcdr_status: 'OPEN',
        oodcdr_olar_client_id: this.webstorage.localSt_client_id,
        companyId: this.userSelectedStore.serviceCompanyId,
        oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
        LocationName: this.locationDetails.mm_stores.store_name,
        LocationAddress: this.locationDetails.mm_stores.store_address,
        oodcdr_address_landmark: this.userServiceBase.landMark,
        oodcdr_address_url: this.userSelectedStore.serviceAddressURL,
        oodcdr_latlang: this.userSelectedStore.serviceLatLang,
        string_net_total_amount: this.TotalOrderAmount.toString(),
        string_cashback_total_amount: this.CashbackEarnedAmount.toString(),
        EmailBase: {
          ToMailList: emailBase.emailToMailList,
          Subject: emailBase.emailSubject,
          Body: emailBase.emailBody
        },
        Payments: {
          amount: this.PaymentAmount.toFixed(2).toString(),
          oodcdrp_status: 'STARTED',
          oodcdrp_bank_code: 'MB2U0227',
          oodcdrp_currency: 'MYR',
          oodcdrp_transaction_description: 'DELIVERY',
          oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
          key_index: '1',
          payment_id: this.getPaymentId(paymentType).toString()
        },
        sales_orders: salesorder,
        Key: this.webstorage.localSt_olar_key,
        olarme_cashback_discount: null,
        Voucher: null,
        Referrals: null
      };
      if (olarcashback) {
        deliverydata.olarme_cashback_discount = olarcashback;
        deliverydata.string_cashback_total_amount = olarcashback.amount;
      }
      if (voucherApplied) {
        deliverydata.Voucher = voucherApplied;
        deliverydata.string_cashback_total_amount = Number(deliverydata.string_cashback_total_amount) + Number(voucherApplied.amount);
      }
    }
    if (deliverydata.oodcdr_address_url.length === 0) {
      //deliverydata.oodcdr_address_url = "http://maps.google.co.uk/maps?q=" + this.webstorage.localSt_latlng;
      deliverydata.oodcdr_address_url = "http://maps.google.co.uk/maps?q=" + this.cookie.cookie_latlng;
    }
    if (deliverydata.oodcdr_address.length === 0) {
      deliverydata.oodcdr_address = this.cookie.cookie_user_location;
    }
    if (deliverydata.oodcdr_latlang.length === 0) {
      //deliverydata.oodcdr_latlang = this.webstorage.localSt_latlng;
      let destination = this.cookie.cookie_latlng;
      if (this.cookie.cookie_latlng_delivery_address_change) {
        destination = this.cookie.cookie_latlng_delivery_address_change;
      }
      deliverydata.oodcdr_latlang = destination;
    }

    deliverydata.oodcdr_mobile = this.ecomservice.encryptWithKey(deliverydata.oodcdr_mobile);
    deliverydata.oodcdr_name = this.ecomservice.encryptWithKey(deliverydata.oodcdr_name);
    if (deliverydata.oodcdr_address !== null && deliverydata.oodcdr_address !== undefined) {
      deliverydata.oodcdr_address = deliverydata.oodcdr_address.trim();
    }
    deliverydata.oodcdr_address = deliverydata.oodcdr_address;
    this.DeliveryPayment(paymentType, userStoreIndex, deliverydata, deliverydata.Payments);
  }

  getDeliveryDataReferrals(storeBase: StoreServiceBase, cartBase: StoreCartBase, paymentType): any {
    const salesorder = {
      sales_order_status: 'DRAFT',
      //sales_order_delivery_charge_total: cartBase.orderDeliveryCharge,
      order_gross_total: cartBase.orderSubTotal.toFixed(2).toString(),
      order_tax_total: cartBase.orderTax.toFixed(2).toString(),
      delivery_charge_total: cartBase.orderDeliveryCharge.toFixed(2).toString(),
      order_net_total_amount: cartBase.orderTotal.toFixed(2).toString(),
      order_discount_total: cartBase.orderDiscountReferral.toFixed(2).toString(),
      sales_order_location_guid: storeBase.serviceLocationGuid,
      sales_order_id: this.getOrderID(),
      sales_order_remarks: '',
      sales_order_notes: '',
      sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
      mm_sales_order_items: [],
      mm_sales_order_surcharges: []
    };


    cartBase.orderItems.forEach(item => {
      // item
      const saleorderitem = {
        soi_item_guid: item.itemGuid,
        soi_item_name: item.itemName,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };
      // variants
      item.variantList.forEach(variant => {
        if (variant.selected) {
          const saleorderitemvariant = {
            soiscvsd_soi_guid: item.itemGuid,
            soiscvsd_isvsd_guid: variant.variantGuid,
            soiscvsd_name: variant.variantName ? variant.variantName : '',
            soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
            price: variant.variantSalePrice.toString(),
            soiscvsd_tax_guid: variant.variantTaxGuid,
            tax_rate: variant.variantTaxRate.toFixed(2).toString(),
            tax_amount: variant.variantTaxEach.toFixed(2).toString(),
            quantity: variant.variantQty.toString(),
            soiscvsd_status: 'ORDERED',
            soiscvsd_notes: item.specialRequest ? item.specialRequest : '',
            discount_total_item_amount: variant.totalDiscountAmount.toString(),
            total_amount: variant.totalPriceAfterDiscount.toString(),
          };
          saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
        }
      });
      saleorderitem.item_has_variant = saleorderitem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      // modifier set
      item.modifierSetList.forEach(set => {
        if (set.quantity > 0) {
          const modifierset = {
            somm_soi_guid: item.itemGuid,
            somm_imm_guid: set.modifiermappingGuid,
            somm_modifier_name: set.modifierName,
            mm_sales_order_modifier_mapping_options: [],
          };
          set.modifierOptions.forEach(option => {
            if (option.optionQuantity > 0) {
              const modifieroption = {
                sommo_somm_guid: null,
                sommo_immo_guid: option.optionGuid,
                sommo_option_name: option.optionName,
                sommo_tax_guid: option.optionTaxGuid,
                tax_rate: option.optionTaxRate.toFixed(2).toString(),
                tax_amount: option.optionTaxAmt.toFixed(2).toString(),
                price: option.optionSalePrice.toFixed(2).toString(),
                quantity: option.optionQuantity.toFixed(2).toString(),
                discount_total_item_amount: option.totalDiscountAmount.toFixed(2).toString(),
                total_amount: option.totalPriceAfterDiscount.toFixed(2).toString()
              };
              modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
            }
          });
          saleorderitem.mm_sales_order_modifier_mapping.push(modifierset);
        }
      });

      salesorder.mm_sales_order_items.push(saleorderitem);
    });
    const emailBase = new EmailBase();
    emailBase.emailSubject = 'Collection Service Confirmed';
    emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new collection service confirmed!!<br /> Thanks.';
    emailBase.emailToMailList = [];
    //emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
    if (this.settings.oosrcs_reservation_email) {
      let emailList = this.settings.oosrcs_reservation_email.split(',');
      for (let i = 0; i < emailList.length; i++) {
        emailBase.emailToMailList.push(emailList[i]);
      }
    }
    let olarcashback = undefined;
    if (this.discountApplied) {
      olarcashback = {
        ooocd_mod_guid: this.discountApplied.mod_guid,
        amount: this.CashbackEarnedAmount.toString(),
        ooocd_mod_name: this.discountApplied.mod_name,
        ooocd_type: this.discountApplied.mod_business,
        str_percentage: this.discountApplied.mod_percentage + ''
      };
    }
    const deliverydata = {
      oodcdr_guid: this.userSelectedStore.serviceGuid,
      oodcdr_type: this.userSelectedStore.serviceType,
      order_date_time: this.userSelectedStore.serviceDatetime,
      oodcdr_ooa_guid: this.userSelectedStore.serviceLocationAreaId,
      oodcdr_oot_guid: this.userSelectedStore.serviceLocationTableId,
      oodcdr_oot_table_name: this.userSelectedStore.serviceLocationTableName,
      oodcdr_location_guid: this.userSelectedStore.serviceLocationGuid,
      oodcdr_name: this.userSelectedStore.serviceUsername,
      oodcdr_mobile: this.userSelectedStore.serviceUserMobilenumber,
      oodcdr_country_dial_code: this.userSelectedStore.serviceUserDialCode,
      oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
      oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
      oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
      oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
      oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: 'OPEN',
      oodcdr_olar_client_id: this.webstorage.localSt_client_id,
      companyId: this.userSelectedStore.serviceCompanyId,
      oodcdr_is_qrcodescan: this.userSelectedStore.serviceQRScanned,
      LocationName: this.locationDetails.mm_stores.store_name,
      LocationAddress: this.locationDetails.mm_stores.store_address,
      oodcdr_address_landmark: this.userServiceBase.landMark,
      oodcdr_address_url: this.userSelectedStore.serviceAddressURL,
      oodcdr_latlang: this.userSelectedStore.serviceLatLang,
      string_net_total_amount: this.TotalOrderAmount.toString(),
      string_cashback_total_amount: this.referralDiscountAmount.toString(),
      EmailBase: {
        ToMailList: emailBase.emailToMailList,
        Subject: emailBase.emailSubject,
        Body: emailBase.emailBody
      },
      Payments: {
        amount: this.PaymentAmount.toFixed(2).toString(),
        oodcdrp_status: 'STARTED',
        oodcdrp_bank_code: 'MB2U0227',
        oodcdrp_currency: 'MYR',
        oodcdrp_transaction_description: this.serviceType,
        oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
        key_index: '1',
        payment_id: this.getPaymentId(paymentType).toString()
      },
      sales_orders: salesorder,
      Key: this.webstorage.localSt_olar_key,
      olarme_cashback_discount: null
    };
    if (deliverydata.oodcdr_address_url.length === 0) {
      //deliverydata.oodcdr_address_url = "http://maps.google.co.uk/maps?q=" + this.webstorage.localSt_latlng;
      let destination = this.cookie.cookie_latlng;
      if (this.cookie.cookie_latlng_delivery_address_change) {
        destination = this.cookie.cookie_latlng_delivery_address_change;
      }
      deliverydata.oodcdr_address_url = "http://maps.google.co.uk/maps?q=" + destination;
    }
    if (deliverydata.oodcdr_address.length === 0) {

      //deliverydata.oodcdr_address = this.webstorage.localSt_current_location;
      deliverydata.oodcdr_address = this.cookie.cookie_user_location;
    }
    if (deliverydata.oodcdr_latlang.length === 0) {
      //deliverydata.oodcdr_latlang = this.webstorage.localSt_latlng;
      let destination = this.cookie.cookie_latlng;
      if (this.cookie.cookie_latlng_delivery_address_change) {
        destination = this.cookie.cookie_latlng_delivery_address_change;
      }
      deliverydata.oodcdr_latlang = destination;
    }
    return deliverydata;
  }

  // Method to encrypt the plain data
  /*
  DeliveryEncryptedData(plainData): any {
    const saleorderEncrypted = {
      sales_order_status: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_status),
      //sales_order_delivery_charge_total: plainData.sales_orders.sales_order_delivery_charge_total,
      delivery_charge_total: this.ecomservice.encryptWithKey(plainData.sales_orders.delivery_charge_total),
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_id),
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: this.ecomservice.encryptWithKey(plainData.sales_orders.sales_order_company_sell_prices),
      mm_sales_order_items: []
    };

    //saleitems
    plainData.sales_orders.mm_sales_order_items.forEach(item => {

      const saleitemEncrypted = {
        soi_item_guid: item.soi_item_guid,
        soi_item_name: this.ecomservice.encryptWithKey(item.soi_item_name),
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };

      // variants
      item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
        const variantEncrypted = {
          soiscvsd_soi_guid: item.soi_item_guid,
          soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
          soiscvsd_name: variant.soiscvsd_name ? this.ecomservice.encryptWithKey(variant.soiscvsd_name) : '',
          soiscvsd_sku: this.ecomservice.encryptWithKey(variant.soiscvsd_sku),
          price: this.ecomservice.encryptWithKey(variant.price),
          soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
          tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
          tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
          quantity: this.ecomservice.encryptWithKey(variant.quantity),
          soiscvsd_status: this.ecomservice.encryptWithKey(variant.soiscvsd_status),
          soiscvsd_notes: variant.soiscvsd_notes ? this.ecomservice.encryptWithKey(variant.soiscvsd_notes) : '',
          discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
          total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
        };
        saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(variantEncrypted);
      });

      //modifiers
      item.mm_sales_order_modifier_mapping.forEach(set => {
        const modifiersetEncrypted = {
          somm_soi_guid: set.somm_soi_guid,
          somm_imm_guid: set.somm_imm_guid,
          somm_modifier_name: this.ecomservice.encryptWithKey(set.somm_modifier_name),
          mm_sales_order_modifier_mapping_options: [],
        };

        //options
        set.mm_sales_order_modifier_mapping_options.forEach(option => {
          const modifieroptionEncrypted = {
            sommo_immo_guid: option.sommo_immo_guid,
            sommo_option_name: this.ecomservice.encryptWithKey(option.sommo_option_name),
            sommo_tax_guid: option.sommo_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
            price: this.ecomservice.encryptWithKey(option.price),
            quantity: this.ecomservice.encryptWithKey(option.quantity),
            discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
            total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
          };
          modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
        });
        saleitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
      });

      saleitemEncrypted.item_has_variant = this.ecomservice.encryptWithKey(saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false');
      saleorderEncrypted.mm_sales_order_items.push(saleitemEncrypted);
    });

    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });
    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_mod_name),
        ooocd_type: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.ooocd_type),
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }
    const deliverydataEncrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: this.ecomservice.encryptWithKey(plainData.oodcdr_type),
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests && plainData.oodcdr_special_requests.length > 1 ? this.ecomservice.encryptWithKey(plainData.oodcdr_special_requests) : '',
      oodcdr_company_guid: plainData.oodcdr_company_guid,
      oodcdr_status: this.ecomservice.encryptWithKey(plainData.oodcdr_status),
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: this.ecomservice.encryptWithKey(plainData.companyId),
      LocationName: this.ecomservice.encryptWithKey(plainData.LocationName),
      LocationAddress: this.ecomservice.encryptWithKey(plainData.LocationAddress),
      oodcdr_address_landmark: this.ecomservice.encryptWithKey(plainData.oodcdr_address_landmark),
      oodcdr_address_url: this.ecomservice.encryptWithKey(plainData.oodcdr_address_url),
      oodcdr_latlang: this.ecomservice.encryptWithKey(plainData.oodcdr_latlang),
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: this.ecomservice.encryptWithKey(plainData.EmailBase.Subject),
        Body: this.ecomservice.encryptWithKey(plainData.EmailBase.Body)
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_status),
        oodcdrp_bank_code: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_bank_code),
        oodcdrp_currency: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_currency),
        oodcdrp_transaction_description: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_transaction_description),
        oodcdrp_ipaddress: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_ipaddress),
        key_index: this.ecomservice.encryptWithKey(plainData.Payments.key_index),
        payment_id: this.ecomservice.encryptWithKey(plainData.Payments.payment_id)
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      deliverydataEncrypted.olarme_cashback_discount = cashbackencrypted;
    }
    if (deliverydataEncrypted.oodcdr_address_url.length === 0) {
      deliverydataEncrypted.oodcdr_address_url = this.ecomservice.encryptWithKey("http://maps.google.co.uk/maps?q=" + this.webstorage.localSt_latlng);
    }
    if (deliverydataEncrypted.oodcdr_address.length === 0) {
      deliverydataEncrypted.oodcdr_address = this.ecomservice.encryptWithKey(this.webstorage.localSt_current_location);
    }
    if (deliverydataEncrypted.oodcdr_latlang.length === 0) {
      deliverydataEncrypted.oodcdr_latlang = this.ecomservice.encryptWithKey(this.webstorage.localSt_latlng);
    }

    return deliverydataEncrypted;
  }
  */

  DeliveryEncryptedData(plainData): any {
    const saleorderEncrypted = {
      sales_order_status: plainData.sales_orders.sales_order_status,
      delivery_charge_total: this.ecomservice.encryptWithKey(plainData.sales_orders.delivery_charge_total),
      order_gross_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_gross_total),
      order_tax_total: this.ecomservice.encryptWithKey(plainData.sales_orders.order_tax_total),
      order_net_total_amount: this.ecomservice.encryptWithKey(plainData.sales_orders.order_net_total_amount),
      order_discount_total: plainData.sales_orders.order_discount_total ? this.ecomservice.encryptWithKey(plainData.sales_orders.order_discount_total) : plainData.sales_orders.order_discount_total,
      sales_order_location_guid: plainData.sales_orders.sales_order_location_guid,
      sales_order_id: plainData.sales_orders.sales_order_id,
      sales_order_remarks: plainData.sales_orders.sales_order_remarks,
      sales_order_notes: plainData.sales_orders.sales_order_notes,
      sales_order_company_sell_prices: plainData.sales_orders.sales_order_company_sell_prices,
      mm_sales_order_items: []
    };

    //saleitems
    plainData.sales_orders.mm_sales_order_items.forEach(item => {

      const saleitemEncrypted = {
        soi_item_guid: item.soi_item_guid,
        soi_item_name: item.soi_item_name,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: ''
      };

      // variants
      item.mm_sales_order_items_standard_composite_variant_service_details.forEach(variant => {
        const variantEncrypted = {
          soiscvsd_soi_guid: item.soi_item_guid,
          soiscvsd_isvsd_guid: variant.soiscvsd_isvsd_guid,
          soiscvsd_name: variant.soiscvsd_name,
          soiscvsd_sku: variant.soiscvsd_sku,
          price: this.ecomservice.encryptWithKey(variant.price),
          soiscvsd_tax_guid: variant.soiscvsd_tax_guid,
          tax_rate: this.ecomservice.encryptWithKey(variant.tax_rate),
          tax_amount: this.ecomservice.encryptWithKey(variant.tax_amount),
          quantity: this.ecomservice.encryptWithKey(variant.quantity),
          soiscvsd_status: variant.soiscvsd_status,
          soiscvsd_notes: variant.soiscvsd_notes,
          discount_total_item_amount: variant.discount_total_item_amount ? this.ecomservice.encryptWithKey(variant.discount_total_item_amount) : '',
          total_amount: variant.total_amount ? this.ecomservice.encryptWithKey(variant.total_amount) : ''
        };
        saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.push(variantEncrypted);
      });

      //modifiers
      item.mm_sales_order_modifier_mapping.forEach(set => {
        const modifiersetEncrypted = {
          somm_soi_guid: set.somm_soi_guid,
          somm_imm_guid: set.somm_imm_guid,
          somm_modifier_name: set.somm_modifier_name,
          mm_sales_order_modifier_mapping_options: [],
        };

        //options
        set.mm_sales_order_modifier_mapping_options.forEach(option => {
          const modifieroptionEncrypted = {
            sommo_immo_guid: option.sommo_immo_guid,
            sommo_option_name: option.sommo_option_name,
            sommo_tax_guid: option.sommo_tax_guid,
            tax_rate: this.ecomservice.encryptWithKey(option.tax_rate),
            tax_amount: this.ecomservice.encryptWithKey(option.tax_amount),
            price: this.ecomservice.encryptWithKey(option.price),
            quantity: this.ecomservice.encryptWithKey(option.quantity),
            discount_total_item_amount: option.discount_total_item_amount ? this.ecomservice.encryptWithKey(option.discount_total_item_amount) : '',
            total_amount: option.total_amount ? this.ecomservice.encryptWithKey(option.total_amount) : ''
          };
          modifiersetEncrypted.mm_sales_order_modifier_mapping_options.push(modifieroptionEncrypted);
        });
        saleitemEncrypted.mm_sales_order_modifier_mapping.push(modifiersetEncrypted);
      });

      saleitemEncrypted.item_has_variant = saleitemEncrypted.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      saleorderEncrypted.mm_sales_order_items.push(saleitemEncrypted);
    });

    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });
    // cashback
    let cashbackencrypted = undefined;
    if (plainData.olarme_cashback_discount) {
      cashbackencrypted = {
        ooocd_mod_guid: plainData.olarme_cashback_discount.ooocd_mod_guid,
        amount: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.amount),
        ooocd_mod_name: plainData.olarme_cashback_discount.ooocd_mod_name,
        ooocd_type: plainData.olarme_cashback_discount.ooocd_type,
        str_percentage: this.ecomservice.encryptWithKey(plainData.olarme_cashback_discount.str_percentage)
      };
    }
    const deliverydataEncrypted = {
      oodcdr_guid: plainData.oodcdr_guid,
      oodcdr_type: plainData.oodcdr_type,
      order_date_time: this.ecomservice.encryptWithKey(plainData.order_date_time),
      oodcdr_ooa_guid: plainData.oodcdr_ooa_guid,
      oodcdr_oot_guid: plainData.oodcdr_oot_guid,
      oodcdr_location_guid: plainData.oodcdr_location_guid,
      oodcdr_name: this.ecomservice.encryptWithKey(plainData.oodcdr_name),
      oodcdr_mobile: this.ecomservice.encryptWithKey(plainData.oodcdr_mobile),
      oodcdr_country_dial_code: this.ecomservice.encryptWithKey(plainData.oodcdr_country_dial_code),
      oodcdr_address: plainData.oodcdr_address ? this.ecomservice.encryptWithKey(plainData.oodcdr_address) : '',
      oodcdr_postal_code: plainData.oodcdr_postal_code ? this.ecomservice.encryptWithKey(plainData.oodcdr_postal_code) : '',
      oodcdr_city: plainData.oodcdr_city ? this.ecomservice.encryptWithKey(plainData.oodcdr_city) : '',
      oodcdr_email: plainData.oodcdr_email ? this.ecomservice.encryptWithKey(plainData.oodcdr_email) : '',
      oodcdr_special_requests: plainData.oodcdr_special_requests && plainData.oodcdr_special_requests.length > 1 ? this.ecomservice.encryptWithKey(plainData.oodcdr_special_requests) : '',
      oodcdr_company_guid: plainData.oodcdr_company_guid,
      oodcdr_status: plainData.oodcdr_status,
      oodcdr_olar_client_id: plainData.oodcdr_olar_client_id,
      companyId: plainData.companyId,
      LocationName: plainData.LocationName,
      LocationAddress: plainData.LocationAddress,
      oodcdr_address_landmark: this.ecomservice.encryptWithKey(plainData.oodcdr_address_landmark),
      oodcdr_address_url: this.ecomservice.encryptWithKey(plainData.oodcdr_address_url),
      oodcdr_latlang: this.ecomservice.encryptWithKey(plainData.oodcdr_latlang),
      string_net_total_amount: this.ecomservice.encryptWithKey(plainData.string_net_total_amount),
      string_cashback_total_amount: plainData.string_cashback_total_amount ? this.ecomservice.encryptWithKey(plainData.string_cashback_total_amount) : '',
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: plainData.EmailBase.Subject,
        Body: plainData.EmailBase.Body
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: plainData.Payments.oodcdrp_status,
        oodcdrp_bank_code: plainData.Payments.oodcdrp_bank_code,
        oodcdrp_currency: plainData.Payments.oodcdrp_currency,
        oodcdrp_transaction_description: plainData.Payments.oodcdrp_transaction_description,
        oodcdrp_ipaddress: plainData.Payments.oodcdrp_ipaddress,
        key_index: plainData.Payments.key_index,
        payment_id: plainData.Payments.payment_id
      },
      sales_orders: saleorderEncrypted,
      Key: plainData.Key,
      olarme_cashback_discount: null
    };
    if (cashbackencrypted) {
      deliverydataEncrypted.olarme_cashback_discount = cashbackencrypted;
    }
    if (deliverydataEncrypted.oodcdr_address_url.length === 0) {
      //deliverydataEncrypted.oodcdr_address_url = this.ecomservice.encryptWithKey("http://maps.google.co.uk/maps?q=" + this.webstorage.localSt_latlng);
      deliverydataEncrypted.oodcdr_address_url = this.ecomservice.encryptWithKey("http://maps.google.co.uk/maps?q=" + this.cookie.cookie_latlng);
    }
    if (deliverydataEncrypted.oodcdr_address.length === 0) {
      //deliverydataEncrypted.oodcdr_address = this.ecomservice.encryptWithKey(this.webstorage.localSt_current_location);
      deliverydataEncrypted.oodcdr_address = this.ecomservice.encryptWithKey(this.cookie.cookie_user_location);
    }
    if (deliverydataEncrypted.oodcdr_latlang.length === 0) {
      //deliverydataEncrypted.oodcdr_latlang = this.ecomservice.encryptWithKey(this.webstorage.localSt_latlng);
      let destination = this.cookie.cookie_latlng;
      if (this.cookie.cookie_latlng_delivery_address_change) {
        destination = this.cookie.cookie_latlng_delivery_address_change;
      }
      deliverydataEncrypted.oodcdr_latlang = this.ecomservice.encryptWithKey(destination);
    }

    return deliverydataEncrypted;
  }

  // Method to make the payment
  DeliveryPayment(paymentType, userStoreIndex, deliveryEncrypted, paymentDetails) {
    this.retrycount = this.retrycount + 1;
    this.ecomservice.httpPost(EcomNetworkUtils.POST_ADD_SERVICE, deliveryEncrypted, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.status === 200) {
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceGuid = response.value;
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          this.webstorage.sessionSt_frompage = 'payment';
          if (paymentType !== 'Reserved') {
            const referencenumber = response.listValue.ooco_payment_reference;
            const order = new orderDetails();
            order.PaymentType = paymentType;
            order.Reference_Number = referencenumber;
            order.Amount = this.PaymentAmount,
              order.Currency = paymentDetails.oodcdrp_currency,
              order.Transaction_Description = paymentDetails.oodcdrp_transaction_description;
            order.Customer_Name = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUsername;
            order.Customer_Email = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserEmail;
            order.Customer_Contact = this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceUserMobilenumber;
            order.Customer_IP = this.webstorage.localSt_ip;
            this.sendPaymentRequest(order);
          } else {
            this.router.navigate(['status-delivery'], { queryParams: { companyId: this.userSelectedStore.serviceCompanyId, serviceId: response.value } });
          }
        } else {
          if (this.retrycount < 3) {
            this.saveDelivery(paymentType);
          } else {
            this.alerts = [];
            this.alerts.push({
              type: 'warning',
              msg: 'currently not able to proceed try after sometimes!',
              timeout: 5000,
              isOpen: true
            });
          }
        }
      }
    });
  }

  // Method to save the reservation data to db
  saveReservation(paymentType) {

    // get the current location user in and the respective store
    let storeselectedIndex = -1;
    const storeselected = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      storeselectedIndex = index;
      return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.userServiceBase.userCurrentLocationIn) && obj.serviceType == this.serviceType;
    });
    const locationSelected = this.webstorage.sessionSt_orderlocation_details;
    const toMailList = [];
    storeselected.serviceEmail.emailToMailList.forEach(element => {
      if (element) {
        toMailList.push(element);
      }
    });
    const depositamount: string = locationSelected.ools_reservation_deposit;
    const input = {
      ctr_guid: storeselected.serviceGuid,
      start_datetime: storeselected.serviceDatetime,
      ctr_customer_name: storeselected.serviceUsername,
      ctr_country_dial_code: storeselected.serviceUserDialCode,
      ctr_customer_phone_number: storeselected.serviceUserMobilenumber,
      ctr_customer_email: storeselected.serviceUserEmail ? storeselected.serviceUserEmail : '',
      pax: storeselected.servicepax.toString(),
      //ctr_dinein_table_guid: storeselected.serviceLocationTableId,
      ctr_status: storeselected.serviceStatus,
      ctr_notes: storeselected.serviceRemarks ? storeselected.serviceRemarks : '',
      ctr_location_guid: storeselected.serviceLocationGuid,
      ctr_company_guid: storeselected.serviceCompanyGuid,
      ctr_olar_client_id: this.webstorage.localSt_client_id,
      ctr_area_Id: storeselected.serviceLocationAreaId ? storeselected.serviceLocationAreaId : '',
      ctr_area_name: storeselected.serviceLocationAreaName ? storeselected.serviceLocationAreaName : '',
      companyId: storeselected.serviceCompanyId,
      LocationName: this.locationDetails.mm_stores.store_name,
      LocationAddress: this.locationDetails.mm_stores.store_address,
      ctr_transaction_id: this.getOrderID(),
      EmailBase: {
        ToMailList: toMailList,
        Subject: storeselected.serviceEmail.emailSubject,
        Body: storeselected.serviceEmail.emailBody
      },
      Payments: {
        amount: depositamount.toString(),
        oodcdrp_status: 'STARTED',
        oodcdrp_bank_code: 'MB2U0227',
        oodcdrp_currency: 'MYR',
        oodcdrp_transaction_description: this.serviceType,
        oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
        key_index: '1',
        payment_id: this.getPaymentId(paymentType).toString()
      },
      Key: this.webstorage.localSt_olar_key,
    };
    this.webstorage.localSt_user_service_request = this.userServiceBase;
    const encryptedData = this.ReservationEncryptedData(input);
    this.ReservationPayment(paymentType, storeselectedIndex, encryptedData, input.Payments);
  }

  // Method to encrypt the plain data
  ReservationEncryptedData(plainData): any {
    const toMailEncrypted = [];
    plainData.EmailBase.ToMailList.forEach(mail => {
      toMailEncrypted.push(this.ecomservice.encryptWithKey(mail));
    });
    // const reservationEncrypted = {
    //   ctr_guid: plainData.ctr_guid,
    //   start_datetime: this.ecomservice.encryptWithKey(plainData.start_datetime),
    //   ctr_customer_name: this.ecomservice.encryptWithKey(plainData.ctr_customer_name),
    //   ctr_country_dial_code: this.ecomservice.encryptWithKey(plainData.ctr_country_dial_code),
    //   ctr_customer_phone_number: this.ecomservice.encryptWithKey(plainData.ctr_customer_phone_number),
    //   ctr_customer_email: plainData.ctr_customer_email ? this.ecomservice.encryptWithKey(plainData.ctr_customer_email) : '',
    //   pax: this.ecomservice.encryptWithKey(plainData.pax),
    //   //ctr_dinein_table_guid: plainData.ctr_dinein_table_guid,
    //   ctr_status: this.ecomservice.encryptWithKey(plainData.ctr_status),
    //   ctr_notes: plainData.ctr_notes ? this.ecomservice.encryptWithKey(plainData.ctr_notes) : '',
    //   ctr_location_guid: plainData.ctr_location_guid,
    //   ctr_company_guid: plainData.ctr_company_guid,
    //   ctr_olar_client_id: plainData.ctr_olar_client_id,
    //   ctr_area_Id: plainData.ctr_area_Id ? this.ecomservice.encryptWithKey(plainData.ctr_area_Id) : '',
    //   ctr_area_name: plainData.ctr_area_name ? this.ecomservice.encryptWithKey(plainData.ctr_area_name) : '',
    //   companyId: this.ecomservice.encryptWithKey(plainData.companyId),
    //   LocationName: this.ecomservice.encryptWithKey(plainData.LocationName),
    //   LocationAddress: this.ecomservice.encryptWithKey(plainData.LocationAddress),
    //   ctr_transaction_id: this.ecomservice.encryptWithKey(plainData.ctr_transaction_id),
    //   EmailBase: {
    //     ToMailList: toMailEncrypted,
    //     Subject: this.ecomservice.encryptWithKey(plainData.EmailBase.Subject),
    //     Body: this.ecomservice.encryptWithKey(plainData.EmailBase.Body)
    //   },
    //   Payments: {
    //     amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
    //     oodcdrp_status: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_status),
    //     oodcdrp_bank_code: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_bank_code),
    //     oodcdrp_currency: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_currency),
    //     oodcdrp_transaction_description: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_transaction_description),
    //     oodcdrp_ipaddress: this.ecomservice.encryptWithKey(plainData.Payments.oodcdrp_ipaddress),
    //     key_index: this.ecomservice.encryptWithKey(plainData.Payments.key_index),
    //     payment_id: this.ecomservice.encryptWithKey(plainData.Payments.payment_id)
    //   },
    //   Key: plainData.Key,
    // };
    const reservationEncrypted = {
      ctr_guid: plainData.ctr_guid,
      start_datetime: plainData.start_datetime,
      ctr_customer_name: this.ecomservice.encryptWithKey(plainData.ctr_customer_name),
      ctr_country_dial_code: this.ecomservice.encryptWithKey(plainData.ctr_country_dial_code),
      ctr_customer_phone_number: this.ecomservice.encryptWithKey(plainData.ctr_customer_phone_number),
      ctr_customer_email: plainData.ctr_customer_email ? this.ecomservice.encryptWithKey(plainData.ctr_customer_email) : '',
      pax: plainData.pax,
      //ctr_dinein_table_guid: plainData.ctr_dinein_table_guid,
      ctr_status: plainData.ctr_status,
      ctr_notes: plainData.ctr_notes,
      ctr_location_guid: plainData.ctr_location_guid,
      ctr_company_guid: plainData.ctr_company_guid,
      ctr_olar_client_id: plainData.ctr_olar_client_id,
      ctr_area_Id: plainData.ctr_area_Id,
      ctr_area_name: plainData.ctr_area_name,
      companyId: plainData.companyId,
      LocationName: plainData.LocationName,
      LocationAddress: plainData.LocationAddress,
      ctr_transaction_id: plainData.ctr_transaction_id,
      EmailBase: {
        ToMailList: toMailEncrypted,
        Subject: plainData.EmailBase.Subject,
        Body: plainData.EmailBase.Body
      },
      Payments: {
        amount: this.ecomservice.encryptWithKey(plainData.Payments.amount),
        oodcdrp_status: plainData.Payments.oodcdrp_status,
        oodcdrp_bank_code: plainData.Payments.oodcdrp_bank_code,
        oodcdrp_currency: plainData.Payments.oodcdrp_currency,
        oodcdrp_transaction_description: plainData.Payments.oodcdrp_transaction_description,
        oodcdrp_ipaddress: plainData.Payments.oodcdrp_ipaddress,
        key_index: plainData.Payments.key_index,
        payment_id: plainData.Payments.payment_id
      },
      Key: plainData.Key,
    };
    return reservationEncrypted;
  }

  // Method to make the payment
  ReservationPayment(paymentType, storeselectedIndex, reservationEncrypted, paymentDetails) {
    this.retrycount = this.retrycount + 1;
    this.ecomservice.httpPost(EcomNetworkUtils.POST_ADD_RESERVATION, reservationEncrypted, '', true,true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.status === 200) {
          this.userServiceBase.selectedStoreServiceList[storeselectedIndex].serviceGuid = response.value;
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          if (paymentType !== 'Reserved') {
            const locationSelected = this.webstorage.sessionSt_orderlocation_details;
            const depositamount = locationSelected.ools_reservation_deposit;
            const referencenumber = response.listValue.ooco_payment_reference;
            const order = new orderDetails();
            order.PaymentType = paymentType;
            order.Reference_Number = referencenumber;
            order.Amount = depositamount,
              order.Currency = paymentDetails.oodcdrp_currency,
              order.Transaction_Description = paymentDetails.oodcdrp_transaction_description;
            order.Customer_Name = this.userServiceBase.selectedStoreServiceList[storeselectedIndex].serviceUsername;
            order.Customer_Email = this.userServiceBase.selectedStoreServiceList[storeselectedIndex].serviceUserEmail;
            order.Customer_Contact = this.userServiceBase.selectedStoreServiceList[storeselectedIndex].serviceUserMobilenumber;
            order.Customer_IP = this.webstorage.localSt_ip;
            this.sendPaymentRequest(order);
            //this.saveUserAddress(useraddress,true);
          } else {
            //this.saveUserAddress(useraddress,false);
            this.webstorage.sessionSt_frompage = 'payment';
            this.webstorage.sessionSt_topage = 'confirm-reservation';
            this.router.navigate([this.webstorage.sessionSt_topage], { queryParams: { companyId: this.userServiceBase.selectedStoreServiceList[storeselectedIndex].serviceCompanyId, serviceId: response.value } });
          }
        } else {
          if (this.retrycount < 3) {
            this.saveReservation(paymentType);
          } else {
            this.alerts = [];
            this.alerts.push({
              type: 'warning',
              msg: 'currently not able to proceed try after sometimes!',
              timeout: 5000,
              isOpen: true
            });
          }
        }
      }
    });

  }

  saveUserAddress(input,displayLoading) {
    this.ecomservice.httpPost(EcomNetworkUtils.POST_SAVE_USER_ADDRESS, input, '', true,displayLoading).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {

        }
      }
    });
  }

  // Method to get the payment id by payment type
  getPaymentId(selectedPaymentType) {
    let paymentType = 1;
    switch (selectedPaymentType) {
      case 'Reserved':
        this.PaymentTypeSelectedName = 'Pay at counter';
        paymentType = PaymentId.Reserved;
        break;
      case 'Visa_MasterCard':
        this.PaymentTypeSelectedName = 'Visa Master Card';
        paymentType = PaymentId.Visa_MasterCard;
        break;
      case 'FPX_PERSONAL_ACCOUNT':
        this.PaymentTypeSelectedName = 'FPX Personal Account';
        paymentType = PaymentId.FPX_PERSONAL_ACCOUNT;
        break;
      case 'AMEX_CreditCard':
        this.PaymentTypeSelectedName = 'Amex Credit Card';
        paymentType = PaymentId.AMEX_CreditCard;
        break;
      case 'Alipay_Spot_QR':
        this.PaymentTypeSelectedName = 'Alipay QR';
        paymentType = PaymentId.Alipay_Spot_QR;
        break;
      case 'UPOP':
        this.PaymentTypeSelectedName = 'Union Pay';
        paymentType = PaymentId.UPOP;
        break;
      case 'UPI_QR_Code':
        this.PaymentTypeSelectedName = 'Union Pay QR';
        paymentType = PaymentId.UPI_QR_Code;
        break;
      case 'Internet_Banking':
        this.PaymentTypeSelectedName = 'Internet Banking';
        paymentType = PaymentId.Internet_Banking;
        break;
      case 'FPX_CORPORATE_ACCOUNT':
        this.PaymentTypeSelectedName = 'FPX Corporate Account';
        paymentType = PaymentId.FPX_CORPORATE_ACCOUNT;
        break;
      case 'MerchanTrade':
        this.PaymentTypeSelectedName = 'Merchant Trade';
        paymentType = PaymentId.MerchanTrade;
        break;
      case 'Axiata_Boost':
        this.PaymentTypeSelectedName = 'Boost';
        paymentType = PaymentId.Axiata_Boost;
        break;
      case 'Maybank_QR':
        this.PaymentTypeSelectedName = 'Maybank QR';
        paymentType = PaymentId.Maybank_QR;
        break;
      case 'DiGi_VCash':
        this.PaymentTypeSelectedName = 'DIGI VCash';
        paymentType = PaymentId.DiGi_VCash;
        break;
      case 'WeChat_Pay':
        this.PaymentTypeSelectedName = 'WeChat Pay';
        paymentType = PaymentId.WeChat_Pay;
        break;
      case 'Alipay_Online':
        this.PaymentTypeSelectedName = 'Alipay Online';
        paymentType = PaymentId.Alipay_Online;
        break;
      case 'AirAsia_BIG':
        this.PaymentTypeSelectedName = 'AirAsia Big';
        paymentType = PaymentId.AirAsia_BIG;
        break;
      case 'Grab_Pay':
        this.PaymentTypeSelectedName = 'Grab Pay';
        paymentType = PaymentId.Grab_Pay;
        break;
      case 'Internet_Banking_MayBank':
        this.PaymentTypeSelectedName = 'Internet Banking Maybank';
        paymentType = PaymentId.Internet_Banking_MayBank;
        break;
      case 'Internet_Banking_CIMB':
        this.PaymentTypeSelectedName = 'Internet Banking CIMB';
        paymentType = PaymentId.Internet_Banking_CIMB;
        break;
      case 'Internet_Banking_RHB':
        this.PaymentTypeSelectedName = 'Internet Banking RHB';
        paymentType = PaymentId.Internet_Banking_RHB;
        break;
      case 'Internet_Banking_Public_Bank':
        this.PaymentTypeSelectedName = 'Internet Banking Public Bank';
        paymentType = PaymentId.Internet_Banking_Public_Bank;
        break;
      case 'Internet_Banking_Hong_Leong_Bank':
        this.PaymentTypeSelectedName = 'Internet Banking Hong Leong Bank';
        paymentType = PaymentId.Internet_Banking_Hong_Leong_Bank;
        break;
      case 'Internet_Banking_AmBank':
        this.PaymentTypeSelectedName = 'Internet Banking AmBank';
        paymentType = PaymentId.Internet_Banking_AmBank;
        break;
      case 'Internet_Banking_Bank_Rakyat':
        this.PaymentTypeSelectedName = 'Internet Banking Bank Rakyat';
        paymentType = PaymentId.Internet_Banking_Bank_Rakyat;
        break;
      case 'Internet_Banking_Bank_Muamalat':
        this.PaymentTypeSelectedName = 'Internet Banking Bank Muamalat';
        paymentType = PaymentId.Internet_Banking_Bank_Muamalat;
        break;
      case 'Internet_Banking_BSN':
        this.PaymentTypeSelectedName = 'Internet Banking BSN';
        paymentType = PaymentId.Internet_Banking_BSN;
        break;
      case 'Hong_Leong_Bank_Scan_and_Pay':
        this.PaymentTypeSelectedName = 'Hong Leong Bank Scan & Pay';
        paymentType = PaymentId.Hong_Leong_Bank_Scan_and_Pay;
        break;
      case 'Touch_n_Go':
        this.PaymentTypeSelectedName = 'Touch n go';
        paymentType = PaymentId.Touch_n_Go;
        break;
      case 'Diners_Club':
        this.PaymentTypeSelectedName = 'Dinners Club';
        paymentType = PaymentId.Diners_Club;
        break;
    }
    return paymentType;
  }

  // Method to send the payment request to bank server
  sendPaymentRequest(request: orderDetails) {
    //signature for request as per doc
    // Signature Value = "Merchant Key" + "Revpay Merchant ID" + "Reference Number" + "Amount" + "Currency" 
    const merchantKey = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1');
    const merchantId = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'); //olarconfig.rhPayments.merchant_id;
    const referenceNumber = request.Reference_Number;
    const signatureValue = merchantKey + merchantId + referenceNumber + request.Amount + request.Currency;
    const signature = this.ecomservice.generateSHA512Hash(signatureValue)
    const input = {
      Revpay_Merchant_ID: merchantId,
      Payment_ID: this.getPaymentId(request.PaymentType),
      Bank_Code: 'MBB0228',
      Reference_Number: request.Reference_Number,
      Amount: request.Amount,
      Currency: request.Currency,
      Transaction_Description: request.Transaction_Description,
      Customer_Name: request.Customer_Name,
      Customer_Email: request.Customer_Email,
      Customer_Contact: request.Customer_Contact,
      Customer_IP: request.Customer_IP,
      Installment_Plan: '',
      Installment_Term: '',
      Key_Index: 1,
      Signature: signature,
      Return_URL: this.ecomservice.GetOlarConfigValue('rhPayments_paymentfrontreturnurl')
    }
    this.rhPaymentForm.controls['Revpay_Merchant_ID'].setValue(input.Revpay_Merchant_ID);
    this.rhPaymentForm.controls['Payment_ID'].setValue(input.Payment_ID);
    this.rhPaymentForm.controls['Bank_Code'].setValue(input.Bank_Code);
    this.rhPaymentForm.controls['Reference_Number'].setValue(input.Reference_Number);
    this.rhPaymentForm.controls['Amount'].setValue(input.Amount);
    this.rhPaymentForm.controls['Currency'].setValue(input.Currency);
    this.rhPaymentForm.controls['Transaction_Description'].setValue(input.Transaction_Description);
    this.rhPaymentForm.controls['Customer_Name'].setValue(input.Customer_Name);
    this.rhPaymentForm.controls['Customer_Email'].setValue(input.Customer_Email);
    this.rhPaymentForm.controls['Customer_Contact'].setValue(input.Customer_Contact);
    this.rhPaymentForm.controls['Customer_IP'].setValue(input.Customer_IP);
    this.rhPaymentForm.controls['Installment_Plan'].setValue(input.Installment_Plan);
    this.rhPaymentForm.controls['Installment_Term'].setValue(input.Installment_Term);
    this.rhPaymentForm.controls['Key_Index'].setValue(input.Key_Index);
    this.rhPaymentForm.controls['Signature'].setValue(input.Signature);
    this.rhPaymentForm.controls['Return_URL'].setValue(input.Return_URL);
    const requestUrl = this.ecomservice.GetOlarConfigValue('rhPayments_paymentrequesturl');
    document.forms[0].action = requestUrl;
    document.forms[0].submit();
  }

  AmBankPaymentRequest(request: orderDetails) {
    //signature for request as per doc
    // Signature Value = "Merchant Key" + "Revpay Merchant ID" + "Reference Number" + "Amount" + "Currency" 
    const merchantAccountNumber = this.ecomservice.GetOlarConfigValue('AmBank_MerchantAccountNo'); //olarconfig.AmBank.UAT.MerchantAccountNo;
    const transactionPassword = this.ecomservice.GetOlarConfigValue('AmBank_TxnPassword'); // olarconfig.AmBank.UAT.TxnPassword;
    const transactionType = 2;
    const merchantTransactionId = this.ecomservice.GetOlarConfigValue('AmBank_TID');
    const responseType = 'HTTP';
    const returnUrl = this.ecomservice.GetOlarConfigValue('AmBank_return_url');
    const transactionDescription = 'olar online transaction';
    // signature without credit card
    const signatureValue = transactionPassword + request.Amount + merchantAccountNumber + merchantTransactionId + responseType + returnUrl + transactionType + transactionDescription;
    const signature = this.ecomservice.generateSHA512Hash(signatureValue)

    this.AmBankPaymentForm.controls['MERCHANT_ACC_NO'].setValue(merchantAccountNumber);
    this.AmBankPaymentForm.controls['MERCHANT_TRANID'].setValue(merchantTransactionId);
    this.AmBankPaymentForm.controls['AMOUNT'].setValue(request.Amount);
    this.AmBankPaymentForm.controls['TRANSACTION_TYPE'].setValue(transactionType);
    this.AmBankPaymentForm.controls['SECURE_SIGNATURE'].setValue(signature);
    this.AmBankPaymentForm.controls['RESPONSE_TYPE'].setValue(responseType);
    this.AmBankPaymentForm.controls['RETURN_URL'].setValue(returnUrl);
    this.AmBankPaymentForm.controls['TXN_DESC'].setValue(transactionDescription);
    this.AmBankPaymentForm.controls['CUSTOMER_ID'].setValue('cust001');
    this.AmBankPaymentForm.controls['FR_HIGHRISK_EMAIL'].setValue('harish.hg@magnumasia-ipo.com');
    this.AmBankPaymentForm.controls['FR_CUSTOMER_IP'].setValue('192.168.1.180');
    const requestUrl = this.ecomservice.GetOlarConfigValue('AmBank_sale_url');
    document.forms[1].action = requestUrl;
    document.forms[1].submit();
  }

  // Method to submit the form
  onSubmit(e) {
    e.target.submit();
  }

  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }

  // Method to handle the modal close click event
  onCloseClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  // Method to generate orderid
  getOrderID() {
    // Company, location, day, month, year,hour,minutes,seconds,milliseconds
    const day = new Date().getDate() + 1;
    const month = new Date().getMonth() + 1;
    // const yearlength = new Date().getFullYear().toString().length;
    const year = new Date().getFullYear().toString().substr(2);
    const hour = new Date().getHours();
    const minute = new Date().getMinutes();
    const second = new Date().getSeconds();
    const milliseconds = new Date().getMilliseconds();
    const orderId = '' + day + month + year + hour + minute + second + milliseconds;
    return orderId;
  }

  onChangePaymentClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  onProceedPaymentClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
    if (this.serviceType === 'DINE_IN') {
      this.saveDineIn(this.paymentTypeSelected);
    } else if (this.serviceType === 'COLLECTION') {
      this.saveCollection(this.paymentTypeSelected);
    } else if (this.serviceType === 'DELIVERY') {
      this.saveDelivery(this.paymentTypeSelected);
    } else if (this.serviceType === 'RESERVATION') {
      this.saveReservation(this.paymentTypeSelected);
    }
  }

  onSignUpNowClick() {
    if (this.signupform.invalid) {
      Object.keys(this.signupform.controls).forEach(key => {
        this.signupform.get(key).markAsDirty();
      });
      return;
    } else {
      this.modalRef.hide();
      //$('.modal').css({"display": "none"});
      this.webstorage.sessionSt_frompage = 'payment';
      this.router.navigate(['login'], { queryParams: { usermob: this.signupform.controls['mobile'].value.number } });
    }
  }

}

// class to get the order details for payment
class orderDetails {
  Reference_Number: string;
  Amount: number;
  Currency: string;
  Transaction_Description: string;
  Customer_Name: string;
  Customer_Email: string;
  Customer_Contact: string;
  Customer_IP: string;
  PaymentType: string;
}

// payment id enums
enum PaymentId {
  Reserved = 1,
  Visa_MasterCard = 2,
  FPX_PERSONAL_ACCOUNT = 3,
  AMEX_CreditCard = 4,
  Alipay_Spot_QR = 5,
  UPOP = 6,
  UPI_QR_Code = 7,
  Internet_Banking = 8,
  FPX_CORPORATE_ACCOUNT = 9,
  MerchanTrade = 10,
  Axiata_Boost = 11,
  Maybank_QR = 12,
  DiGi_VCash = 13,
  WeChat_Pay = 14,
  Alipay_Online = 15,
  AirAsia_BIG = 16,
  Grab_Pay = 17,
  Internet_Banking_MayBank = 18,
  Internet_Banking_CIMB = 19,
  Internet_Banking_RHB = 20,
  Internet_Banking_Public_Bank = 21,
  Internet_Banking_Hong_Leong_Bank = 22,
  Internet_Banking_AmBank = 23,
  Internet_Banking_Bank_Rakyat = 24,
  Internet_Banking_Bank_Muamalat = 25,
  Internet_Banking_BSN = 26,
  Hong_Leong_Bank_Scan_and_Pay = 27,
  Touch_n_Go = 28,
  Diners_Club = 29
}
